package com.evoapps.evoshift.viewmodels

import com.evoapps.evoshift.domain.model.ShiftBreak
import com.evoapps.evoshift.domain.model.RosterPublishing
import com.evoapps.evoshift.domain.model.awaitsPublishing
import com.evoapps.evoshift.observability.AnalyticsEvent
import com.evoapps.evoshift.observability.AppTelemetry

import com.evoapps.evoshift.domain.usecase.billing.ObservePlanActiveUseCase
import com.evoapps.evoshift.domain.model.Capability
import com.evoapps.evoshift.domain.model.capabilitiesAt
import com.evoapps.evoshift.domain.model.CompensationModel
import com.evoapps.evoshift.domain.model.FinancialEngagement
import com.evoapps.evoshift.domain.market.payroll.PayrollRules
import com.evoapps.evoshift.domain.schedule.LabourProfile
import com.evoapps.evoshift.domain.schedule.RosterIssue
import com.evoapps.evoshift.domain.schedule.RosterIssueReport
import com.evoapps.evoshift.domain.schedule.LabourReport
import com.evoapps.evoshift.domain.market.Market
import com.evoapps.evoshift.domain.repository.UserRepository
import kotlinx.coroutines.awaitAll
import com.evoapps.evoshift.domain.model.RosterIds
import com.evoapps.evoshift.domain.model.DailyRecordIds
import com.evoapps.evoshift.domain.util.plannedTimeRange
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.async
import com.evoapps.evoshift.domain.usecase.shift.MarkShiftsOpenUseCase
import com.evoapps.evoshift.ui.util.UiText
import com.evoapps.evoshift.ui.util.toUiText
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.evoapps.evoshift.domain.model.Availability
import com.evoapps.evoshift.domain.model.BusyElsewhere
import com.evoapps.evoshift.domain.schedule.ElsewhereIssue
import com.evoapps.evoshift.domain.usecase.roster.GetBusyElsewhereUseCase
import com.evoapps.evoshift.domain.model.AvailabilitySlot
import com.evoapps.evoshift.domain.model.Roster
import com.evoapps.evoshift.domain.model.Shift
import com.evoapps.evoshift.domain.model.isBorrowed
import com.evoapps.evoshift.domain.model.ShiftTemplate
import com.evoapps.evoshift.domain.model.TimeRange
import com.evoapps.evoshift.domain.model.User
import com.evoapps.evoshift.domain.repository.WorkplaceRepository
import com.evoapps.evoshift.domain.usecase.AssignUserToShiftUseCase
import com.evoapps.evoshift.domain.usecase.GetDayClosuresUseCase
import com.evoapps.evoshift.domain.legal.DayClosure
import com.evoapps.evoshift.domain.usecase.DetectRosterConflictsUseCase
import com.evoapps.evoshift.domain.usecase.GetRosterAvailabilityUseCase
import com.evoapps.evoshift.domain.usecase.PublishRosterUseCase
import com.evoapps.evoshift.domain.usecase.UnassignShiftFromEmployeeUseCase
import com.evoapps.evoshift.domain.usecase.roster.GetRosterShiftsUseCase
import com.evoapps.evoshift.domain.usecase.roster.GetRosterUseCase
import com.evoapps.evoshift.domain.usecase.auth.GetCurrentUserUseCase
import com.evoapps.evoshift.domain.usecase.shift.CreateShiftUseCase
import com.evoapps.evoshift.domain.usecase.shift.DeleteShiftUseCase
import com.evoapps.evoshift.domain.usecase.CalculateShiftCostUseCase
import evoshift.composeapp.generated.resources.roster_shift_restored
import com.evoapps.evoshift.domain.usecase.shift.ShiftFactory
import com.evoapps.evoshift.domain.usecase.shift.UpdateShiftUseCase
import com.evoapps.evoshift.domain.usecase.user.GetAssignableEmployeesUseCase
import com.evoapps.evoshift.domain.util.calculateDurationHours
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.CompletableDeferred
import kotlinx.coroutines.delay
import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalDate
import kotlinx.datetime.todayIn
import kotlinx.datetime.Month
import com.evoapps.evoshift.domain.model.RosterStatus
import com.evoapps.evoshift.domain.schedule.SchedulePlan
import com.evoapps.evoshift.domain.usecase.schedule.ApplyAutoScheduleUseCase
import com.evoapps.evoshift.domain.usecase.schedule.PlanAutoScheduleUseCase
import com.evoapps.evoshift.domain.usecase.schedule.SuggestAutoScheduleWithAiUseCase
import com.evoapps.evoshift.domain.schedule.ai.AiAssignFailure
import evoshift.composeapp.generated.resources.auto_assign_ai_fallback_disabled
import evoshift.composeapp.generated.resources.auto_assign_ai_fallback_failed
import evoshift.composeapp.generated.resources.auto_assign_ai_fallback_not_allowed
import evoshift.composeapp.generated.resources.auto_assign_ai_fallback_plan
import evoshift.composeapp.generated.resources.auto_assign_ai_fallback_quota
import evoshift.composeapp.generated.resources.auto_assign_ai_fallback_too_large
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.actual_work_absence_failed
import evoshift.composeapp.generated.resources.actual_work_saved_absence
import evoshift.composeapp.generated.resources.actual_work_saved_nobody
import evoshift.composeapp.generated.resources.actual_work_saved_planned
import evoshift.composeapp.generated.resources.split_absence_failed
import evoshift.composeapp.generated.resources.split_done
import evoshift.composeapp.generated.resources.split_undone
import evoshift.composeapp.generated.resources.who_worked_recorded
import evoshift.composeapp.generated.resources.roster_move_started
import evoshift.composeapp.generated.resources.roster_cell_copied
import evoshift.composeapp.generated.resources.roster_cells_skipped
import evoshift.composeapp.generated.resources.roster_grid_undone
import evoshift.composeapp.generated.resources.roster_published
import evoshift.composeapp.generated.resources.auto_assign_applied
import evoshift.composeapp.generated.resources.auto_assign_skipped
import com.evoapps.evoshift.domain.model.ConflictType
import com.evoapps.evoshift.domain.model.DayStaffAlert
import com.evoapps.evoshift.domain.model.ShiftLeadRule
import com.evoapps.evoshift.domain.model.StaffReadiness
import com.evoapps.evoshift.domain.usecase.staff.GetTeamReadinessUseCase
import com.evoapps.evoshift.domain.staffing.MonthStaffing
import com.evoapps.evoshift.domain.usecase.finance.GetStaffingHintsUseCase
import com.evoapps.evoshift.domain.usecase.finance.GetLabourBudgetUseCase
import com.evoapps.evoshift.domain.usecase.finance.RosterBudgetContext
import com.evoapps.evoshift.domain.budget.BudgetEffect
import com.evoapps.evoshift.domain.budget.LabourBudgetRules
import com.evoapps.evoshift.domain.budget.LabourBudgetStatus
import com.evoapps.evoshift.domain.schedule.CopySource
import com.evoapps.evoshift.domain.usecase.roster.CopyPreview
import com.evoapps.evoshift.domain.usecase.roster.CopyShiftsUseCase
import com.evoapps.evoshift.saves.SaveKind
import com.evoapps.evoshift.domain.usecase.roster.PlannedDaysMode
import evoshift.composeapp.generated.resources.copy_undone
import evoshift.composeapp.generated.resources.copy_tool_month_unreadable
import evoshift.composeapp.generated.resources.copy_tool_unreadable
import evoshift.composeapp.generated.resources.error_permission_denied
import org.jetbrains.compose.resources.StringResource
import evoshift.composeapp.generated.resources.copy_days_copied
import evoshift.composeapp.generated.resources.copy_day_nothing_on_day
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.isoDayNumber
import kotlinx.datetime.number
import kotlinx.datetime.plus

enum class DayViewMode { SHIFTS, EMPLOYEES }

data class AssignmentConflict(
    val shiftId: String,
    val userId: String,
    val details: AssignUserToShiftUseCase.AssignmentResult.ConflictFound,
    /** A new shift from this template on this day (SH-47 check before creating it), not an existing shift. */
    val newShift: Pair<LocalDate, ShiftTemplate>? = null,
    /** SH-169: the grid edit this assignment finishes (a drag): offered for undo once it is saved. */
    val undo: GridUndo? = null,
    /** SH-169: what cancelling puts back (a shift dragged to another day goes back to its day). */
    val revert: GridUndo? = null
)

data class PublishSuccessData(
    val month: Int,
    val year: Int,
    val totalHours: Double,
    /** Shifts in the published roster: assigned plus open. */
    val totalShifts: Int,
    val filledShifts: Int,
    val openShifts: Int = 0
)

/**
 * SH-53: the rules' proposal for the month's unassigned shifts (PlanAutoScheduleUseCase), shown
 * in a sheet before anything is written. Facts only: the screen words the reasons.
 */
data class AutoAssignUiState(
    /** The plan is being worked out (the sheet shows progress). */
    val isPlanning: Boolean = true,
    val plan: SchedulePlan? = null,
    /** Proposals the manager keeps, by shift id: all of them at first. */
    val accepted: Set<String> = emptySet(),
    /** Contracted hours are not the person's to read, so they are not used as limits. */
    val targetsNotUsed: Boolean = false,
    /** SH-90: "Suggest with AI" is offered (the gate allows it and the server says it is on). */
    val aiOffered: Boolean = false,
    /** SH-90: this plan was asked with AI suggestions (rows may carry the AI badge). */
    val usedAi: Boolean = false,
    /** SH-90: why the plan shown is the rules' alone although the AI was asked. */
    val aiFallback: UiText? = null
) {
    val acceptedCount: Int get() = plan?.assignments?.count { it.shiftId in accepted } ?: 0
}

/** SH-114: the last copy, until its snackbar is gone: Undo removes exactly these shifts. */
/** SH-199: and the shifts a Replace removed, put back by Undo exactly as they were. */
data class CopyUndo(val shiftIds: List<String>, val restore: List<Shift> = emptyList())

/** SH-158: the last deleted shift, until its snackbar is gone: Undo creates it again. */
data class DeleteUndo(val shift: Shift)

/** SH-169: what the grid's last edit did, for its snackbar. */
enum class GridEditKind { UNASSIGNED, MOVED, ADDED }

/**
 * SH-169: the grid's last edit (Delete on a cell, a drag, a template on selected cells, a paste)
 * until its snackbar is gone: Undo puts the shifts of [before] back as they were and removes the
 * shifts of [createdIds]. Ctrl/Cmd+Z does the same.
 */
data class GridUndo(val kind: GridEditKind, val before: List<Shift> = emptyList(), val createdIds: List<String> = emptyList()) {
    /** How many shifts the edit touched (the snackbar's number). */
    val count: Int get() = before.size + createdIds.size
}

/** SH-169: a person's day in the grid. */
data class GridCell(val userId: String, val date: LocalDate)

/** SH-169: a cell's shift as copied (Ctrl/Cmd+C): its times and requirements, for pasting on another cell. */
data class CopiedShift(val startTime: String, val endTime: String, val role: String?, val skills: List<String>) {
    fun asTemplate(): ShiftTemplate = ShiftTemplate(id = "custom", name = role.orEmpty(), startTime = startTime, endTime = endTime, role = role, skills = skills)
}

/** SH-169: the grid's zoom (its cells' width), kept on this device. */
internal const val GRID_ZOOM_KEY = "roster_grid_zoom"
internal const val GRID_ZOOM_MIN = 0.6f
internal const val GRID_ZOOM_MAX = 2.0f
internal const val GRID_ZOOM_STEP = 0.1f

/** SH-187: how long the month's derived figures wait for the next change before being worked out. */
internal const val DERIVED_DEBOUNCE_MS = 150L

/** Unassigned shifts at publish time: open ones are offered to the team, leftovers are removed. */
data class PublishConfirmation(
    val leftoverShifts: Int,
    val openShifts: Int
)

data class RosterDetailUiState(
    val isLoading: Boolean = true,
    val roster: Roster? = null,
    val shiftsByDate: Map<LocalDate, List<Shift>> = emptyMap(),
    val availabilityByUserId: Map<String, Availability> = emptyMap(),
    val availabilitySlots: List<AvailabilitySlot> = emptyList(),
    /** The workplace's roles, offered when a shift's role is set (SH-130). */
    val availableRoles: List<String> = emptyList(),
    val selectedDate: LocalDate? = null,
    val dayViewMode: DayViewMode = DayViewMode.SHIFTS,
    val availableEmployees: List<User> = emptyList(),
    val shiftTemplates: List<ShiftTemplate> = emptyList(),
    val assigningShiftId: String? = null,
    val pendingConflict: AssignmentConflict? = null,
    val error: UiText? = null,
    /** SH-168: the month could not be read: Try again instead of an empty month. */
    val loadError: UiText? = null,
    val publishSuccessData: PublishSuccessData? = null,
    val firstDayOfWeek: Int = 1,
    val publishConfirmation: PublishConfirmation? = null,
    /** SH-263: the month's published shifts deleted since its last publish (those who publish only). */
    val removedShifts: List<com.evoapps.evoshift.domain.model.RemovedShift> = emptyList(),
    val editingShift: Shift? = null,
    /** The month is being published (a progress dialog blocks the screen until it is done). */
    val isPublishing: Boolean = false,
    /** Shifts that overlap another shift of the same person or leave < 11 h rest (DetectRosterConflictsUseCase). */
    val conflictingShiftIds: Set<String> = emptySet(),
    /**
     * Each person's contracted hours this month (declared hours, or FTE × the month's working
     * hours), where their pay terms are readable; the sidebar compares the planned hours with it.
     */
    val targetHoursByUserId: Map<String, Double> = emptyMap(),
    /** What the person may do at the roster's workplace: publishing, printing, contracted hours. */
    val capabilities: Set<Capability> = emptySet(),
    /** SH-47: each person's medical exam / OHS statuses (managers), for the grid and the guard. */
    val readinessByUserId: Map<String, StaffReadiness> = emptyMap(),
    /** SH-47: the workplace refuses assigning someone with an expired exam or training. */
    val blockExpiredStaffChecks: Boolean = false,
    /** SH-55: the days the workplace's Sunday policy closes (non-trading Sundays, holidays). */
    val closedDays: Map<LocalDate, DayClosure> = emptyMap(),
    /** SH-53: the auto-assign sheet, while it is open. */
    val autoAssign: AutoAssignUiState? = null,
    /** A one-off confirmation for the snackbar (e.g. how many shifts auto-assign filled). */
    val notice: UiText? = null,
    /**
     * SH-54: each day's staffing hint (planned labour % of the expected sales against the
     * workplace's target band); money, so null for those without VIEW_FINANCES.
     */
    val staffing: MonthStaffing? = null,
    /** The workplace's currency, for the expected sales in the staffing hints. */
    val currency: String = DEFAULT_CURRENCY,
    /** SH-104: who leads shifts here (the owner, managers, the workplace's lead positions and skills). */
    val leadRule: ShiftLeadRule = ShiftLeadRule(),
    /** SH-112: each person's contract and month norm, where pay terms are readable (else rest rules only). */
    val labourProfiles: Map<String, LabourProfile> = emptyMap(),
    /** SH-112: full-time hours of the roster's month in the workplace's market. */
    val nominalMonthlyHours: Double = 160.0,
    /** SH-133: the workplace applies the 11 h and 35 h rest to every contract (its own rule). */
    val restRulesForAllContracts: Boolean = true,
    /** SH-226: the forecast for today and the coming days, by date (empty with weather off). */
    val weather: Map<LocalDate, com.evoapps.evoshift.domain.model.DayWeather> = emptyMap(),
    /** SH-205: the "Copy shifts" tool (days, weeks and ranges), while it is open. */
    val copyTool: CopyToolUiState? = null,
    /** SH-171: the days copied with Ctrl/Cmd+C on the grid's day headers, pasted from another header. */
    val copiedDays: Set<LocalDate>? = null,
    /** SH-114: the last copy, offered for undo in the snackbar. */
    val copyUndo: CopyUndo? = null,
    /** SH-158: the shift just deleted, offered for undo in the snackbar ("Shift deleted." / Undo). */
    val deleteUndo: DeleteUndo? = null,
    /** SH-169: the grid's last edit, offered for undo in the snackbar and by Ctrl/Cmd+Z. */
    val gridUndo: GridUndo? = null,
    /** SH-169: the shifts copied from a cell (Ctrl/Cmd+C), pasted with Ctrl/Cmd+V. */
    val copiedShifts: List<CopiedShift>? = null,
    /** SH-169: the grid's cell width scale (Ctrl+scroll, Ctrl +/-), kept on this device. */
    val gridZoom: Float = 1f,
    /** SH-167: a shift whose deleting waits for the confirmation (an assigned shift of a published month). */
    val pendingDelete: Shift? = null,
    /** SH-167: the unassigned shift whose person picker is open in the day sheet (the day stays open). */
    val pickerShiftId: String? = null,
    /** SH-167: the month's approved absences (managers), for the picker's hints. */
    val absences: List<com.evoapps.evoshift.domain.model.Absence> = emptyList(),
    /**
     * SH-115: the workplace's labour budget (off: [LabourBudget.OFF]) and what the month's shifts
     * cost; null for those without VIEW_FINANCES (nothing is read for them).
     */
    val budget: RosterBudgetContext? = null,
    /**
     * SH-135: the team's shifts at their other workplaces (managers; from the server): the same
     * owner's with the workplace's name, another employer's only once published and only the times.
     */
    val busyElsewhere: List<BusyElsewhere> = emptyList(),
    /**
     * SH-210: the month's job interviews per participant and day, shown in their cells as their own
     * kind of event ("Job interview"): never a shift (no staffing, no demand, no marketplace).
     */
    val interviewsByUserAndDate: Map<String, Map<LocalDate, List<com.evoapps.evoshift.domain.model.Interview>>> = emptyMap(),
    /**
     * SH-223: approved remote work and work events per person and day (managers): a small mark in
     * the cell. Neither blocks scheduling; a work event clashing with a shift is a warning.
     */
    val workMarksByUserAndDate: Map<String, Map<LocalDate, Set<com.evoapps.evoshift.domain.model.WorkRequestKind>>> = emptyMap(),
    /**
     * SH-267: the people of the other workplaces of the group the managers may borrow this month
     * (from the server: their answers as given at home, their hours, the days they are away).
     */
    val borrowCandidates: List<com.evoapps.evoshift.domain.model.BorrowCandidate> = emptyList(),
    /**
     * SH-158: the grid's results worked out from the fields above (warnings, hours, budget). A copy
     * carries it along, so a change of anything else (a notice, a dialog, the selected day) keeps the
     * results and their instances; the view model swaps it when one of its inputs changes. Read the
     * results through the properties below: they never use a holder made for other inputs.
     */
    val derived: RosterDerived = RosterDerived(
        shiftsByDate, roster, availableEmployees, labourProfiles, nominalMonthlyHours, restRulesForAllContracts,
        availabilityByUserId, readinessByUserId, busyElsewhere, leadRule, budget, firstDayOfWeek
    )
) {
    /** [derived] when it was made for this state's inputs, else one made for them (taking over what still holds). */
    private val current: RosterDerived by lazy {
        if (derivedIsCurrent()) derived else RosterDerived(
            shiftsByDate, roster, availableEmployees, labourProfiles, nominalMonthlyHours, restRulesForAllContracts,
            availabilityByUserId, readinessByUserId, busyElsewhere, leadRule, budget, firstDayOfWeek,
            previous = derived
        )
    }

    private fun derivedIsCurrent(): Boolean = derived.matches(
        shiftsByDate, roster, availableEmployees, labourProfiles, nominalMonthlyHours, restRulesForAllContracts,
        availabilityByUserId, readinessByUserId, busyElsewhere, leadRule, budget, firstDayOfWeek
    )

    /** SH-158: this state carrying a [derived] made for its inputs, so its copies keep the results. */
    fun withCurrentDerived(): RosterDetailUiState = if (derivedIsCurrent()) this else copy(derived = current)

    /** SH-135: each person's time elsewhere per day, for the grid's cells. */
    val busyElsewhereByUserAndDate: Map<String, Map<LocalDate, List<BusyElsewhere>>> get() = current.busyElsewhereByUserAndDate

    /** SH-135: shifts here that overlap work elsewhere or leave less than 11 hours of rest around it. */
    val elsewhereIssues: Map<String, ElsewhereIssue> get() = current.elsewhereIssues

    /**
     * SH-115: the month's planned labour cost against the budget (per week too when set), from the
     * shifts as they are now: a change shows at once, priced from the cost snapshots until its own
     * snapshot is written. Worked out once per change of its inputs.
     */
    val budgetStatus: LabourBudgetStatus? get() = current.budgetStatus

    /**
     * SH-115: what saving [userId] working [hours] on [date] does to the budget, as a new shift
     * ([shiftId] null) or as a change of that shift; null without a budget or when it cannot be
     * priced (no cost snapshot in the month yet).
     */
    fun budgetEffect(date: LocalDate, shiftId: String?, userId: String?, hours: Double): BudgetEffect? {
        val status = budgetStatus ?: return null
        val shift = shiftId?.let { id -> shiftsByDate.values.firstNotNullOfOrNull { day -> day.firstOrNull { it.id == id } } }
        val delta = budget?.estimate?.deltaOf(shift, userId, hours) ?: return null
        return status.effectOf(date, delta)
    }

    /**
     * Adding and deleting shifts from the day's details: a month being built (a draft, or a
     * published month still changing), by those who build it; not once the plan ended (SH-65).
     */
    val canEditShifts: Boolean
        get() = (roster?.status == RosterStatus.DRAFT || roster?.status == RosterStatus.PUBLISHED) && capabilities.shows(Gate.ROSTER_EDITING)

    /**
     * The estimated employer cost of the shift [shiftId] (null: a new one) worked by [userId] (null:
     * nobody yet) for [hours], for the shift dialogs: its cost snapshot, or the estimate. Money,
     * so null for those without VIEW_FINANCES; also null when it cannot be estimated.
     */
    fun shiftCost(shiftId: String?, userId: String?, hours: Double): Double? {
        val estimate = budget?.estimate ?: return null
        val shift = shiftId?.let { id -> shiftsByDate.values.firstNotNullOfOrNull { day -> day.firstOrNull { it.id == id } } }
        return estimate.costAs(shift, userId, hours)
    }

    /** SH-152: how [shiftCost] is made of its parts (tap the cost to see); null when it cannot be estimated. */
    fun shiftCostExplained(shiftId: String?, userId: String?, hours: Double): com.evoapps.evoshift.domain.explain.Breakdown? {
        val estimate = budget?.estimate ?: return null
        val shift = shiftId?.let { id -> shiftsByDate.values.firstNotNullOfOrNull { day -> day.firstOrNull { it.id == id } } }
        return estimate.explain(shift, userId, hours)
    }

    /** SH-152: the budget header's planned labour cost, person by person (as [budgetStatus] prices the shifts). */
    fun budgetUsedExplained(): com.evoapps.evoshift.domain.explain.Breakdown? {
        val status = budgetStatus ?: return null
        val context = budget ?: return null
        val roster = roster ?: return null
        return LabourBudgetRules.explainUsed(roster.year, roster.month, shiftsByDate.values.flatten(), context.estimate, status.month.used)
    }

    /**
     * SH-167: deleting [shift] asks first only when it takes a shift from someone in a published
     * month; every other delete happens at once, with Undo in the snackbar.
     */
    fun deleteNeedsConfirmation(shift: Shift): Boolean = shift.userId != null && roster?.status == RosterStatus.PUBLISHED

    /** SH-167: the month's unassigned shifts not offered to the team (the strip over the days counts them). */
    val unfilledCount: Int get() = shiftsByDate.values.sumOf { day -> day.count { it.userId == null && !it.isOpen } }

    /**
     * SH-263: the shifts of a published month waiting for the next publish (the Publish button's own
     * rule, [RosterPublishing]), for the banner over the grid and its "Show"; empty for a month never
     * published and for those who do not publish (employees never see it).
     */
    val unpublishedShiftIds: Set<String>
        get() = if (!capabilities.shows(Gate.PUBLISH_ROSTER) || !RosterPublishing.wasPublished(roster?.status)) emptySet()
        else shiftsByDate.values.flatten().filter { it.awaitsPublishing }.mapTo(mutableSetOf()) { it.id }

    /**
     * SH-263: the published shifts deleted since the last publish, for the banner's count and its
     * "Show" (listed there: nothing on the grid to ring); empty where [unpublishedShiftIds] is.
     */
    val unpublishedRemovals: List<com.evoapps.evoshift.domain.model.RemovedShift>
        get() = if (!capabilities.shows(Gate.PUBLISH_ROSTER) || !RosterPublishing.wasPublished(roster?.status)) emptyList() else removedShifts

    /** SH-263: how many changes the banner counts (changed or added shifts and removed ones); 0: no banner. */
    val unpublishedChanges: Int get() = unpublishedShiftIds.size + unpublishedRemovals.size

    /**
     * SH-167: the people the day sheet offers for the unassigned shift [shiftId], best first
     * (AssignCandidates): available, no answer, unavailable; the shift's position and skills only.
     */
    fun assignCandidates(shiftId: String): List<com.evoapps.evoshift.domain.schedule.AssignCandidate> {
        val shift = shiftsByDate.values.firstNotNullOfOrNull { day -> day.firstOrNull { it.id == shiftId } } ?: return emptyList()
        val date = LocalDate.parse(shift.date)
        val day = date.day
        return com.evoapps.evoshift.domain.schedule.AssignCandidates.rank(
            shift = shift,
            team = availableEmployees,
            workplaceId = roster?.workplaceId ?: RosterIds.workplaceIdOf(shift.rosterId),
            dayShifts = shiftsByDate[date].orEmpty(),
            preferences = availabilityByUserId.mapNotNull { (uid, a) -> a.days[day]?.let { uid to it } }.toMap(),
            plannedHours = plannedHoursByUserId,
            targetHours = targetHoursByUserId,
            absences = absences,
            busyElsewhere = busyElsewhereByUserAndDate.mapNotNull { (uid, days) -> days[date]?.let { uid to it } }.toMap()
        )
    }

    /**
     * SH-267: "From your other workplaces": the people of the group the day sheet offers for the
     * unassigned shift [shiftId], ranked as the team is (their home position and skills), each
     * with where they come from; a day they are away at home stands in the way.
     */
    fun guestCandidates(shiftId: String): List<com.evoapps.evoshift.domain.schedule.AssignCandidate> {
        if (borrowCandidates.isEmpty()) return emptyList()
        val shift = shiftsByDate.values.firstNotNullOfOrNull { day -> day.firstOrNull { it.id == shiftId } } ?: return emptyList()
        val date = LocalDate.parse(shift.date)
        return com.evoapps.evoshift.domain.schedule.AssignCandidates.rankGuests(
            shift = shift,
            guests = borrowCandidates,
            workplaceId = roster?.workplaceId ?: RosterIds.workplaceIdOf(shift.rosterId),
            dayShifts = shiftsByDate[date].orEmpty(),
            busyElsewhere = busyElsewhereByUserAndDate.mapNotNull { (uid, days) -> days[date]?.let { uid to it } }.toMap()
        )
    }

    /**
     * SH-267: where each borrowed person comes from: the people offered this month and those on
     * the month's borrowed shifts (uid to their home workplace).
     */
    val guestHomes: Map<String, String>
        get() = shiftsByDate.values.flatten().filter { it.isBorrowed }.associate { it.userId!! to it.borrowedFromWorkplaceId!! } +
            borrowCandidates.associate { it.userId to it.homeWorkplaceId }

    /**
     * SH-267: the grid's people: the team, then the borrowed people with shifts this month (as
     * the picker ranks them: their home position, an engagement here in memory only).
     */
    val gridPeople: List<User>
        get() {
            val team = availableEmployees.mapTo(HashSet()) { it.uid }
            val workplaceId = roster?.workplaceId ?: return availableEmployees
            val onShifts = shiftsByDate.values.flatten().filter { it.isBorrowed && it.userId !in team }
            if (onShifts.isEmpty()) return availableEmployees
            val offered = borrowCandidates.associateBy { it.userId }
            val guests = onShifts.distinctBy { it.userId }.map { shift ->
                offered[shift.userId]?.asTeamMember(workplaceId) ?: com.evoapps.evoshift.domain.model.BorrowCandidate(
                    shift.userId!!, shift.userDisplayName ?: "", null, shift.borrowedFromWorkplaceId!!, "", null, emptyList(), 0.0, emptyMap(), emptySet()
                ).asTeamMember(workplaceId)
            }.sortedBy { it.displayName.lowercase() }
            return availableEmployees + guests
        }

    /** SH-267: the home workplace's name of a borrowed person on the grid (null: one of the team, or not known). */
    fun guestFromName(userId: String): String? =
        borrowCandidates.firstOrNull { it.userId == userId }?.homeWorkplaceName?.takeIf { it.isNotBlank() }

    /**
     * SH-172: the team's answers for [date] in the day's sheet or pane (per slot, without an
     * answer, over-demand, who), as the skeleton editor shows them; null when the month was not
     * asked and nobody answered, or the answers are not the reader's.
     */
    fun dayAnswers(date: LocalDate): com.evoapps.evoshift.domain.schedule.DayAnswerSummary? {
        val roster = roster ?: return null
        if (Capability.REQUEST_AVAILABILITY !in capabilities) return null
        if (roster.availabilityRequestId == null && availabilityByUserId.isEmpty()) return null
        return com.evoapps.evoshift.domain.schedule.DayAnswers.of(
            date, availableEmployees, roster.workplaceId, availabilityByUserId, availabilitySlots, absences, shiftsByDate[date].orEmpty()
        )
    }

    /** SH-114: copying into a month being built (a draft, or a published month: copies stay drafts). */
    val canCopy: Boolean
        get() = (roster?.status == RosterStatus.DRAFT || roster?.status == RosterStatus.PUBLISHED) && capabilities.shows(Gate.ROSTER_EDITING)

    /** SH-53: auto-assign fills a draft month's unassigned shifts; not once the plan ended. */
    val canAutoAssign: Boolean get() = roster?.status == RosterStatus.DRAFT && capabilities.shows(Gate.ROSTER_EDITING)

    /**
     * SH-47/SH-104: the days that are missing a shift lead or, at some time, have only people who
     * need supervision (soft warnings in the day headers and the day sheet); worked out once per change of its inputs.
     */
    val dayWarnings: Map<LocalDate, DayStaffAlert> get() = current.dayWarnings

    /** SH-104: shifts of people who need supervision that fall, at some time, in an uncovered window. */
    val unsupervisedShiftIds: Set<String> get() = current.unsupervisedShiftIds

    /**
     * SH-112: the labour code's warnings on the month as it is now (rest, daily norm, 48 hours,
     * overtime), so every assignment, move or edit shows at once; worked out once per change of its inputs.
     */
    val labourReport: LabourReport get() = current.labourReport

    /**
     * SH-133: every warning the grid shows (conflicts, rest, the labour code, availability,
     * medical exams, the day's lead), by shift and by person, for the marks and their explanations.
     */
    val issues: RosterIssueReport get() = current.issues

    /**
     * SH-133: each person's warnings this month: their own, and the times only people who need
     * supervision work that their shifts fall in.
     */
    val issuesByUserId: Map<String, List<RosterIssue>> get() = current.issuesByUserId

    /** SH-133: the shift of [userId] an issue points at (the first of theirs), to open from the popover. */
    fun shiftOf(issue: RosterIssue, userId: String?): Shift? {
        val all = shiftsByDate.values.flatten()
        val ids = issue.shiftIds
        return all.firstOrNull { it.id in ids && (userId == null || it.userId == userId) } ?: all.firstOrNull { it.id in ids }
    }

    /** SH-112: shifts a labour-code warning points at (marked on the grid). */
    val labourWarningShiftIds: Set<String> get() = current.labourWarningShiftIds

    /** Planned (not clocked) hours per person this month, for the grid's sidebar; worked out once per change of its inputs. */
    val plannedHoursByUserId: Map<String, Double> get() = current.plannedHoursByUserId

    /** People's names by user id (the day details name those without a pay rate). */
    val personNames: Map<String, String> get() = current.personNames

    /** Each person's shifts per day: the grid's cells read this instead of filtering every day per row. */
    val shiftsByUserAndDate: Map<String, Map<LocalDate, List<Shift>>> get() = current.shiftsByUserAndDate
}


class RosterDetailViewModel(
    private val rosterId: String,
    private val getRosterUseCase: GetRosterUseCase,
    private val getRosterShiftsUseCase: GetRosterShiftsUseCase,
    private val publishRosterUseCase: PublishRosterUseCase,
    private val getAssignableEmployeesUseCase: GetAssignableEmployeesUseCase,
    private val getRosterAvailabilityUseCase: GetRosterAvailabilityUseCase,
    private val assignUserToShiftUseCase: AssignUserToShiftUseCase,
    private val unassignShiftFromEmployeeUseCase: UnassignShiftFromEmployeeUseCase,
    private val createShiftUseCase: CreateShiftUseCase,
    private val updateShiftUseCase: UpdateShiftUseCase,
    private val workplaceRepository: WorkplaceRepository,
    private val getCurrentUserUseCase: GetCurrentUserUseCase,
    private val detectRosterConflictsUseCase: DetectRosterConflictsUseCase,
    private val markShiftsOpenUseCase: MarkShiftsOpenUseCase,
    /** For the contract targets in the sidebar; without it the sidebar shows planned hours only. */
    private val userRepository: UserRepository? = null,
    /** The workplace's plan: once it ended the month is shown, not built (SH-65). */
    private val observePlanActive: ObservePlanActiveUseCase? = null,
    /** SH-47 statuses for the grid's warnings and the new-shift check. */
    private val getTeamReadiness: GetTeamReadinessUseCase? = null,
    /** SH-55: the closed days the grid marks; without Firestore, the calendar shipped with the app. */
    private val getDayClosures: GetDayClosuresUseCase = GetDayClosuresUseCase(),
    /** SH-53: auto-assign (rules only, no AI); without them the action is not offered. */
    private val planAutoSchedule: PlanAutoScheduleUseCase? = null,
    private val applyAutoSchedule: ApplyAutoScheduleUseCase? = null,
    /** SH-90: AI suggestions in the auto-assign sheet; without it the option is not offered. */
    private val suggestWithAi: SuggestAutoScheduleWithAiUseCase? = null,
    /** SH-54: the day headers' staffing hints; without it there are none. */
    private val getStaffingHints: GetStaffingHintsUseCase? = null,
    /** SH-114: "Copy from…"; without it the action is not offered. */
    private val copyShifts: CopyShiftsUseCase? = null,
    /** SH-135: the team's shifts at their other workplaces; without it none are shown. */
    private val getBusyElsewhere: GetBusyElsewhereUseCase? = null,
    /** SH-115: the labour budget in the header and the shift dialogs; without it there is none. */
    private val getLabourBudget: GetLabourBudgetUseCase? = null,
    /** Deleting a shift from the day's details or its dialog; without it the action is not offered. */
    private val deleteShiftUseCase: DeleteShiftUseCase? = null,
    /** Catches up the month's missing or stale cost snapshots when it opens (MANAGE_PAY only). */
    private val calculateShiftCost: CalculateShiftCostUseCase? = null,
    /**
     * SH-147: the daily records recomputed after the opening priced shifts, so the Finances
     * screen and the daily results count them too (not only once the month is published again).
     */
    private val regenerateDailyRecords: com.evoapps.evoshift.domain.usecase.finance.RegenerateDailyRecordsUseCase? = null,
    /** SH-148: the app's saves: a write started here finishes even if the screen is left. */
    private val saves: com.evoapps.evoshift.saves.PendingSaves = com.evoapps.evoshift.saves.PendingSaves(),
    /** SH-167: the month's absences for the day sheet's person picker (managers); without it none are hinted. */
    private val absenceRepository: com.evoapps.evoshift.domain.repository.AbsenceRepository? = null,
    /**
     * SH-158: where the heavy month-wide work runs (auto-assign planning, conflict detection), so
     * the grid stays smooth meanwhile; tests pass their main dispatcher.
     */
    private val compute: CoroutineDispatcher = Dispatchers.Default,
    /** SH-169: where the grid's zoom is kept (this device); without it the zoom is not kept. */
    private val localSettings: com.evoapps.evoshift.settings.LocalSettings? = null,
    /** SH-210: the month's interviews for the grid (managers read them; anyone else sees none). */
    private val interviewRepository: com.evoapps.evoshift.domain.repository.InterviewRepository? = null,
    /** SH-226: the forecast in the day headers; without it (or with weather off) there is none. */
    private val observeWeather: com.evoapps.evoshift.domain.usecase.weather.ObserveWorkplaceWeatherUseCase? = null,
    private val today: () -> LocalDate = { com.evoapps.evoshift.domain.util.AppClock.todayIn(kotlinx.datetime.TimeZone.currentSystemDefault()) },
    /** SH-227: the day headers' special days and local events; without it there are none. */
    observeSpecialDays: com.evoapps.evoshift.domain.usecase.specialdays.ObserveSpecialDaysUseCase? = null,
    /** SH-227: adding and changing events from a day's menu; without it the action is not offered. */
    saveLocalEvent: com.evoapps.evoshift.domain.usecase.specialdays.SaveLocalEventUseCase? = null,
    deleteLocalEvent: com.evoapps.evoshift.domain.usecase.specialdays.DeleteLocalEventUseCase? = null,
    /** SH-223: approved remote work and work events for the grid's marks; none without it. */
    private val workRequestRepository: com.evoapps.evoshift.domain.repository.WorkRequestRepository? = null,
    /** SH-236: who actually worked a shift, splitting one and undoing a split; without them not offered. */
    private val recordActualWork: com.evoapps.evoshift.domain.usecase.shift.RecordActualWorkUseCase? = null,
    private val splitShiftUseCase: com.evoapps.evoshift.domain.usecase.shift.SplitShiftUseCase? = null,
    private val undoShiftSplit: com.evoapps.evoshift.domain.usecase.shift.UndoShiftSplitUseCase? = null,
    /** SH-267: people to borrow from the other workplaces of the group; without it none are offered. */
    private val borrowing: com.evoapps.evoshift.domain.repository.BorrowingRepository? = null
) : ViewModel() {

    /** SH-227: the month's special days and the event dialog (state and actions). */
    val specialDays = SpecialDaysController(viewModelScope, observeSpecialDays, saveLocalEvent, deleteLocalEvent, saves)

    private var weatherJob: kotlinx.coroutines.Job? = null

    /** SH-226: follows the workplace's forecast for today and the coming days (written by the server). */
    private fun followWeather(workplace: com.evoapps.evoshift.domain.model.Workplace) {
        val observe = observeWeather ?: return
        weatherJob?.cancel()
        weatherJob = viewModelScope.launch {
            observe.upcoming(workplace, today()).collect { days -> _uiState.update { it.copy(weather = days) } }
        }
    }

    private val _uiState = MutableStateFlow(
        RosterDetailUiState(gridZoom = storedGridZoom(localSettings)).withCurrentDerived()
    )
    val uiState = _uiState.asStateFlow()

    /**
     * SH-158: every state change goes through here (it shadows kotlinx's `update` in this class):
     * the new state carries grid results made for its own inputs, so the next copies (a notice, a
     * dialog, the selected day) keep them instead of working the whole month out again.
     */
    private inline fun MutableStateFlow<RosterDetailUiState>.update(change: (RosterDetailUiState) -> RosterDetailUiState) {
        while (true) {
            val before = value
            val after = change(before).withCurrentDerived()
            if (compareAndSet(before, after)) return
        }
    }
    /** SH-187: the month's live listeners (its shifts, its document), started by the load. */
    private val liveShiftsJob = JobSlot()
    private val liveRosterJob = JobSlot()
    /** Set when the shifts listener ended with an error: the next save starts it again. */
    private var liveShiftsEnded = false

    /**
     * The shifts as stored (the live listener) and, on top, this screen's changes
     * not saved yet: one per shift, the newest wins. The grid shows both, so a change shows at once,
     * a read from before it was saved never takes it back, and a failed save undoes only its shift.
     */
    private var stored: List<Shift> = emptyList()

    /** The people a team re-read was asked for (once each per opening, refreshTeamFor). Before init: the load uses it. */
    private val teamAskedFor = mutableSetOf<String>()
    /** People on the month's shifts who are not in the team (they left), named from their profiles. */
    private val otherNames = HashMap<String, String>()
    private val unsaved = LinkedHashMap<String, UnsavedEdit>()
    private val unsavedNew = LinkedHashMap<String, Shift>()
    private var editCounter = 0L

    private class UnsavedEdit(val token: Long, val change: (Shift) -> Shift)

    /** SH-148: the keys of this month's long saves in [saves]. */
    private val publishKey = "roster:$rosterId:publish"
    private val autoAssignKey = "roster:$rosterId:auto-assign"
    private val copyKey = "roster:$rosterId:copy"

    init {
        loadData()
        followPendingPublish()
        followInterviews()
    }

    /** SH-210: the month's scheduled interviews, by participant and day, kept current. */
    private fun followInterviews() {
        val interviews = interviewRepository ?: return
        viewModelScope.launch {
            interviews.observeForRoster(rosterId).collect { list ->
                val byUser = mutableMapOf<String, MutableMap<LocalDate, MutableList<com.evoapps.evoshift.domain.model.Interview>>>()
                list.filterNot { it.isCancelled }.sortedBy { it.start }.forEach { interview ->
                    val date = runCatching { LocalDate.parse(interview.date) }.getOrNull() ?: return@forEach
                    interview.participantIds.distinct().forEach { uid ->
                        byUser.getOrPut(uid) { mutableMapOf() }.getOrPut(date) { mutableListOf() }.add(interview)
                    }
                }
                _uiState.update { it.copy(interviewsByUserAndDate = byUser) }
            }
        }
    }

    /**
     * SH-148: the month opened again while its publishing still runs (started before the screen
     * was left): the progress shows and Publish waits for it; the month is read again after it.
     */
    private fun followPendingPublish() {
        if (!saves.isPending(publishKey)) return
        _uiState.update { it.copy(isPublishing = true) }
        viewModelScope.launch {
            val result = saves.await<Unit>(publishKey) ?: Result.success(Unit)
            _uiState.update {
                it.copy(
                    isPublishing = false,
                    notice = if (result.isSuccess) UiText.Resource(Res.string.roster_published) else it.notice,
                    error = result.exceptionOrNull()?.toUiText() ?: it.error
                )
            }
            loadData()
        }
    }

    /**
     * Full load: the roster, its shifts and everything the grid needs, read side by side (the
     * workplace comes from the roster id). The grid shows as soon as they are in; conflicts, the
     * slowest query (all of each person's workplaces), follow. Only the first load shows a spinner.
     *
     * SH-187: the shifts come from the live listener from the start (offline, a listener answers
     * from the cache at once where a read waits for the server): its first reading is this load's,
     * the next ones update the grid once it shows. The roster document is followed too, so a
     * status or version changed elsewhere (published by a colleague) arrives.
     */
    private fun loadData() {
        viewModelScope.launch {
            var loadFailed = false
            _uiState.update { it.copy(isLoading = it.roster == null) }
            val workplaceId = RosterIds.workplaceIdOf(rosterId)
            val capabilities = capabilitiesAt(getCurrentUserUseCase(), observePlanActive, workplaceId).first()
            _uiState.update { it.copy(capabilities = capabilities) }
            val firstShifts = CompletableDeferred<Result<List<Shift>>>()
            val shown = CompletableDeferred<Unit>()
            observeShifts(firstShifts, shown)
            if (capabilities.shows(Gate.PUBLISH_ROSTER)) observeRemovedShifts()
            coroutineScope {
                val summary = async { getRosterUseCase(rosterId) }
                val shifts = async { firstShifts.await() }
                // The team's availability is the managers' to read.
                val availability = async {
                    if (Capability.REQUEST_AVAILABILITY in capabilities) getRosterAvailabilityUseCase(rosterId) else Result.success(emptyList())
                }
                val workplace = async { workplaceRepository.getWorkplace(workplaceId) }
                val employees = async { getAssignableEmployeesUseCase(workplaceId) }
                val templates = async { workplaceRepository.getShiftTemplates(workplaceId) }
                val conflicts = async(compute) { detectRosterConflictsUseCase(rosterId) }
                val readiness = async {
                    if (capabilities.shows(Gate.STAFF_STATUS)) getTeamReadiness?.invoke(workplaceId)?.getOrNull().orEmpty() else emptyMap()
                }

                val summaryResult = summary.await()
                val shiftsResult = shifts.await()
                if (summaryResult.isFailure || shiftsResult.isFailure) {
                    conflicts.cancel()
                    liveShiftsJob.cancel()
                    val error = (summaryResult.exceptionOrNull() ?: shiftsResult.exceptionOrNull())?.toUiText()
                    // SH-168: nothing on screen yet: the month offers Try again; else a snackbar.
                    _uiState.update { if (it.roster == null) it.copy(isLoading = false, loadError = error) else it.copy(isLoading = false, error = error) }
                    loadFailed = true
                    return@coroutineScope
                }
                val workplaceDoc = workplace.await().getOrNull()
                val settings = workplaceDoc?.settings
                val team = employees.await().getOrDefault(emptyList())
                stored = named(shiftsResult.getOrThrow(), team)
                _uiState.update {
                    it.copy(
                        isLoading = false,
                        loadError = null,
                        roster = summaryResult.getOrThrow(),
                        shiftsByDate = byDate(stored),
                        availabilityByUserId = availability.await().getOrDefault(emptyList()).associateBy { a -> a.userId },
                        availabilitySlots = settings?.definedAvailabilitySlots ?: emptyList(),
                        availableRoles = settings?.availableRoles ?: emptyList(),
                        availableEmployees = team,
                        shiftTemplates = templates.await().getOrDefault(emptyList()),
                        firstDayOfWeek = settings?.firstDayOfWeek ?: 1,
                        blockExpiredStaffChecks = settings?.blockExpiredStaffChecks ?: false,
                        restRulesForAllContracts = settings?.restRulesForAllContracts ?: true,
                        currency = settings?.currency?.takeIf { c -> c.isNotBlank() } ?: DEFAULT_CURRENCY,
                        leadRule = ShiftLeadRule.of(workplaceDoc),
                        nominalMonthlyHours = summaryResult.getOrThrow().let { r ->
                            PayrollRules.of(settings?.market ?: Market.POLAND).workingHours(r.year, r.month).toDouble()
                        }
                    )
                }
                // The grid shows: the listener's next readings apply from here; people not in the team get named.
                shown.complete(Unit)
                observeRoster()
                refreshTeamFor(stored)
                // SH-47: the team's checks follow the grid (each person's record is a read).
                launch { readiness.await().let { r -> _uiState.update { it.copy(readinessByUserId = r) } } }
                // SH-226: the forecast in the day headers (nothing is read with weather off).
                if (workplaceDoc != null) followWeather(workplaceDoc)
                // SH-227: the month's events and special days (owners and managers edit the events).
                if (workplaceDoc != null) {
                    val roster = summaryResult.getOrThrow()
                    val first = LocalDate(roster.year, roster.month, 1)
                    specialDays.follow(
                        workplaceDoc, first, first.plus(DatePeriod(months = 1)).plus(DatePeriod(days = -1)),
                        user = getCurrentUserUseCase().first(),
                        canEdit = Capability.EDIT_ROSTER in capabilities
                    )
                }
                // SH-55: the closed days (a calendar read only for workplaces not open every Sunday).
                if (settings != null) {
                    val roster = summaryResult.getOrThrow()
                    val closed = getDayClosures(settings, roster.year, roster.month)
                    _uiState.update { it.copy(closedDays = closed) }
                }
                // Contracted hours come from pay terms: only for those who may read them.
                if (capabilities.shows(Gate.PAY_AND_PRIVATE_DATA)) {
                    loadContractTargets(summaryResult.getOrThrow(), _uiState.value.availableEmployees, settings?.market ?: Market.POLAND)
                }
                conflicts.await().getOrNull()?.shiftsWithConflicts?.toSet()?.let { found ->
                    _uiState.update { it.copy(conflictingShiftIds = found) }
                }
                // SH-167: the month's approved absences, hinted in the day sheet's person picker (managers only).
                if (Capability.REQUEST_AVAILABILITY in capabilities) {
                    val roster = summaryResult.getOrThrow()
                    val first = LocalDate(roster.year, roster.month, 1)
                    val last = first.plus(DatePeriod(months = 1)).plus(DatePeriod(days = -1))
                    absenceRepository?.getAbsencesForRoster(workplaceId, first.toString(), last.toString())
                        ?.onSuccess { found ->
                            val approved = found.filter { it.status == com.evoapps.evoshift.domain.model.AbsenceStatus.APPROVED }
                            _uiState.update { it.copy(absences = approved) }
                        }
                }
                // SH-223: approved remote work and work events, marked in the cells (managers only).
                if (Capability.REQUEST_AVAILABILITY in capabilities) {
                    val roster = summaryResult.getOrThrow()
                    workRequestRepository?.forWorkplace(workplaceId)?.onSuccess { found ->
                        _uiState.update { it.copy(workMarksByUserAndDate = WorkMarks.byUserAndDate(found, roster.year, roster.month)) }
                    }
                }
                // SH-135: the team's other workplaces, through the server (managers only).
                if (Capability.REQUEST_AVAILABILITY in capabilities) {
                    val roster = summaryResult.getOrThrow()
                    getBusyElsewhere?.invoke(workplaceId, _uiState.value.availableEmployees, roster.year, roster.month)
                        ?.onSuccess { busy -> _uiState.update { it.copy(busyElsewhere = busy) } }
                }
                // SH-267: the people of the group's other workplaces to borrow, and their time elsewhere.
                if (Capability.EDIT_ROSTER in capabilities) loadBorrowCandidates(workplaceId, summaryResult.getOrThrow())
            }
            if (loadFailed) return@launch
            loadStaffing()
            loadBudget()
            refreshCostSnapshots()
        }
    }

    /**
     * SH-267: who the managers may borrow this month from the other workplaces of the group (from
     * the server), named on the month at once, and their work elsewhere for the picker's warnings.
     * A failed read just offers nobody.
     */
    private suspend fun loadBorrowCandidates(workplaceId: String, roster: Roster) {
        val repository = borrowing ?: return
        val candidates = repository.candidates(workplaceId, roster.year, roster.month).getOrNull()?.takeIf { it.isNotEmpty() } ?: return
        _uiState.update { it.copy(borrowCandidates = candidates) }
        val names = candidates.associate { it.userId to it.displayName }
        otherNames += names
        stored = stored.map { shift -> shift.userId?.takeIf { it in names && shift.userDisplayName.isNullOrBlank() }?.let { shift.copy(userDisplayName = names[it]) } ?: shift }
        publishShifts()
        getBusyElsewhere?.forPeople(workplaceId, candidates.map { it.userId }, roster.year, roster.month)
            ?.onSuccess { busy -> _uiState.update { state -> state.copy(busyElsewhere = state.busyElsewhere + busy.filterNot { it in state.busyElsewhere }) } }
    }

    /** SH-267: the workplace a person on [userId]'s new shift is borrowed from (null: one of the team, or nobody). */
    private fun borrowedFromFor(userId: String?): String? {
        if (userId == null) return null
        val state = _uiState.value
        if (state.availableEmployees.any { it.uid == userId }) return null
        return state.borrowCandidates.firstOrNull { it.userId == userId }?.homeWorkplaceId ?: state.guestHomes[userId]
    }

    /** The name of [userId] for a shift shown at once: the team's, else a borrowed person's. */
    private fun nameFor(userId: String?): String? = userId?.let { uid ->
        _uiState.value.availableEmployees.find { it.uid == uid }?.displayName
            ?: _uiState.value.borrowCandidates.find { it.userId == uid }?.displayName
    }

    /** SH-168: Try again after the month failed to load. */
    fun retry() {
        _uiState.update { it.copy(loadError = null, isLoading = it.roster == null) }
        loadData()
    }

    /**
     * The roster's shifts as they change (this device's saves show at once, others' too: a colleague's
     * edit, a shift claimed from the pool, an approved swap), instead of re-reading the month after
     * every save. Names come from the team already loaded. With [first] and [shown] (the load), the
     * first reading is handed to the load and the next ones wait until the grid shows.
     *
     * A listener that ends with an error (a refusal included: SH-188, the repository answers it with
     * WorkplaceAccessRevokedException, worded as lost access) is shown as the screen's error - never left to end the screen's scope - and started
     * again by the next save ([refreshShifts]); before the grid shows, it fails the load instead.
     */
    private fun observeShifts(first: CompletableDeferred<Result<List<Shift>>>? = null, shown: CompletableDeferred<Unit>? = null) {
        liveShiftsEnded = false
        liveShiftsJob.launch(viewModelScope) {
            getRosterShiftsUseCase.observe(rosterId)
                .distinctUntilChanged()
                .catch { e ->
                    liveShiftsEnded = true
                    if (first?.complete(Result.failure(e)) != true) _uiState.update { it.copy(error = e.toUiText()) }
                }
                .collect { shifts ->
                    if (first?.complete(Result.success(shifts)) == true) return@collect
                    shown?.await()
                    applyLiveShifts(shifts)
                }
        }
    }

    private var removedShiftsJob: kotlinx.coroutines.Job? = null

    /** SH-263: the month's removal records, live (a publish or an Undo clears them). */
    private fun observeRemovedShifts() {
        if (removedShiftsJob?.isActive == true) return
        removedShiftsJob = viewModelScope.launch {
            getRosterShiftsUseCase.observeRemoved(rosterId)
                .catch { emit(emptyList()) }
                .distinctUntilChanged()
                .collect { removed -> _uiState.update { it.copy(removedShifts = removed) } }
        }
    }

    /** A reading of the listener after the grid shows: the same shifts as shown change nothing. */
    private fun applyLiveShifts(shifts: List<Shift>) {
        val named = named(shifts, _uiState.value.availableEmployees)
        refreshTeamFor(named)
        if (sameShifts(named, stored)) return
        stored = named
        publishShifts()
        scheduleDerived()
    }

    /**
     * The shifts named from [team], else from the profiles read for people who left
     * ([otherNames]), else as shown before (the same person on the same shift).
     */
    private fun named(shifts: List<Shift>, team: List<User>): List<Shift> {
        val names = team.associate { it.uid to it.displayName }
        val known = stored.associateBy { it.id }
        return shifts.map { shift ->
            val name = shift.userId?.let { uid ->
                names[uid] ?: otherNames[uid] ?: known[shift.id]?.takeIf { it.userId == uid }?.userDisplayName
            }
            shift.copy(userDisplayName = name ?: shift.userDisplayName)
        }
    }

    /**
     * SH-187: the roster document as it changes: its status and version after a colleague
     * publishes or edits the month. The month's figures (year, month) never change.
     */
    private fun observeRoster() {
        liveRosterJob.launch(viewModelScope) {
            getRosterUseCase.observe(rosterId)
                .distinctUntilChanged()
                .catch { e -> _uiState.update { it.copy(error = e.toUiText()) } }
                .collect { roster -> _uiState.update { if (it.roster == roster) it else it.copy(roster = roster) } }
        }
    }

    /**
     * A shift names someone the team read at opening does not have: typically an employee set up
     * in advance who accepted the invitation meanwhile (their shifts moved from the pre-created
     * profile to their account, functions/shadowMerge.js). The team is read again, once per such
     * person, so the month names them instead of showing their id; people who left stay as named.
     */
    private fun refreshTeamFor(shifts: List<Shift>) {
        val known = _uiState.value.availableEmployees.mapTo(HashSet()) { it.uid }
        // SH-237: also who actually worked a shift and who works a split's other part (the dialogs and lines name them).
        val missing = shifts.flatMapTo(HashSet()) { listOfNotNull(it.userId, it.actualUserId, it.split?.otherUserId) }
            .filter { it !in known && it !in teamAskedFor }
        if (missing.isEmpty()) return
        teamAskedFor += missing
        viewModelScope.launch {
            val team = getAssignableEmployeesUseCase(RosterIds.workplaceIdOf(rosterId)).getOrNull() ?: return@launch
            if (team.any { it.uid in missing }) _uiState.update { it.copy(availableEmployees = team) }
            // SH-187: people who left the team keep their name on the month, from their profile.
            val left = missing.filter { uid -> team.none { it.uid == uid } }
            val repository = userRepository
            // SH-235: through the shared resolver (their profiles; the team was just read).
            if (left.isNotEmpty() && repository != null) {
                otherNames += com.evoapps.evoshift.domain.usecase.user.ResolvePersonNamesUseCase(repository)(
                    RosterIds.workplaceIdOf(rosterId), left, team = emptyList()
                )
            }
            val names = team.associate { it.uid to it.displayName } + otherNames
            stored = stored.map { shift -> shift.userId?.let(names::get)?.let { shift.copy(userDisplayName = it) } ?: shift }
            publishShifts()
            scheduleDerived()
        }
    }

    private var costSnapshotsRefreshed = false

    /**
     * Once per opening, for those who may price (MANAGE_PAY, while the plan runs): prices the
     * month's shifts whose cost snapshot is missing or stale (assigned before snapshots were kept,
     * by someone who may not price, or handed to someone else), then reloads the hints and the
     * budget so the stored figures catch up. Shifts of people without pay rates stay unpriced
     * (the day details name them). A failure is reported, never shown.
     */
    private fun refreshCostSnapshots() {
        val pricing = calculateShiftCost ?: return
        val capabilities = _uiState.value.capabilities
        if (costSnapshotsRefreshed || Capability.MANAGE_PAY !in capabilities || Capability.MAKE_CHANGES !in capabilities) return
        costSnapshotsRefreshed = true
        viewModelScope.launch {
            pricing.refreshRoster(rosterId)
                .onSuccess { priced ->
                    if (priced > 0) {
                        _uiState.value.roster?.takeIf { it.status != com.evoapps.evoshift.domain.model.RosterStatus.LOCKED }?.let { roster ->
                            regenerateDailyRecords?.invoke(roster.workplaceId, roster.id, roster.year, roster.month)
                                ?.onFailure { AppTelemetry.recordNonFatal(it) }
                        }
                        loadStaffing()
                        loadBudget()
                    }
                }
                .onFailure { AppTelemetry.recordNonFatal(it) }
        }
    }

    /**
     * SH-115: the labour budget and the month's cost snapshots, for those who may see money
     * (nothing is read for others). A failed read keeps what is shown.
     */
    private suspend fun loadBudget() {
        val useCase = getLabourBudget ?: return
        if (!_uiState.value.capabilities.shows(Gate.MONEY)) return
        useCase.forRoster(rosterId).onSuccess { context -> _uiState.update { it.copy(budget = context) } }
    }

    /**
     * SH-54: the month's staffing hints from the current shifts and their cost snapshots, for
     * those who may see money (nothing is read for others). A failed read just shows no hints.
     */
    private suspend fun loadStaffing() {
        val hints = getStaffingHints ?: return
        if (!_uiState.value.capabilities.shows(Gate.MONEY)) return
        hints(rosterId).onSuccess { month -> _uiState.update { it.copy(staffing = month) } }
    }

    /** Reads everyone's pay terms side by side; people whose terms can't be read just have no target. */
    private fun loadContractTargets(roster: Roster, employees: List<User>, market: Market) {
        val repository = userRepository ?: return
        viewModelScope.launch {
            val monthHours = PayrollRules.of(market).workingHours(roster.year, roster.month).toDouble()
            val engagements = coroutineScope {
                employees.map { employee ->
                    async {
                        repository.getSensitiveUserData(employee.uid).getOrNull()
                            ?.financialEngagements?.get(roster.workplaceId)?.let { employee.uid to it }
                    }
                }.awaitAll().filterNotNull().toMap()
            }
            val targets = engagements.mapNotNull { (uid, engagement) -> contractHours(engagement, monthHours)?.let { uid to it } }.toMap()
            // SH-112: the contract decides whether the labour code's hours limits apply.
            val labour = engagements.mapValues { (uid, engagement) -> LabourProfile(contract = engagement.contract, monthlyNormHours = targets[uid]) }
            _uiState.update { it.copy(targetHoursByUserId = targets, labourProfiles = labour) }
        }
    }

    /** The day whose shifts the sheet (phone) or the docked pane (wide) shows; null closes it (and its picker). */
    fun onDateSelected(date: LocalDate?) {
        _uiState.update { it.copy(selectedDate = date, pickerShiftId = it.pickerShiftId.takeIf { _ -> date != null && date == it.selectedDate }) }
    }

    /**
     * SH-167: "Assign" on an unassigned shift of the day: the people for it, in the day's sheet. The
     * day stays open; only shifts still without a person, for those who build the month.
     */
    fun openPicker(shiftId: String) {
        if (shiftId.isPending || !canBuild) return
        val shift = allShifts().firstOrNull { it.id == shiftId } ?: return
        if (shift.userId != null) return
        _uiState.update { it.copy(pickerShiftId = shiftId, selectedDate = it.selectedDate ?: LocalDate.parse(shift.date)) }
    }

    /** SH-167: back from the picker to the day's shifts. */
    fun closePicker() {
        _uiState.update { it.copy(pickerShiftId = null) }
    }

    /**
     * SH-167: one tap in the picker assigns [userId] to the picked shift (the same optimistic save
     * and soft validation as anywhere else) and returns to the same day, still open.
     */
    fun assignFromPicker(userId: String) {
        val shiftId = _uiState.value.pickerShiftId ?: return
        _uiState.update { it.copy(pickerShiftId = null) }
        assignShift(shiftId, userId)
    }

    /**
     * SH-167: the delete button of a shift. An unassigned shift, or one in a month not published
     * yet, goes at once (the snackbar offers Undo); an assigned shift of a published month asks
     * first ([pendingDelete], then [confirmDelete]). Returns whether it was deleted now.
     */
    fun requestDelete(shift: Shift): Boolean {
        if (deleteShiftUseCase == null || shift.id.isPending || !_uiState.value.canEditShifts) return false
        if (_uiState.value.deleteNeedsConfirmation(shift)) {
            _uiState.update { it.copy(pendingDelete = shift, editingShift = null) }
            return false
        }
        deleteShift(shift.id)
        return true
    }

    /** SH-167: the confirmation said Delete. */
    fun confirmDelete() {
        val shift = _uiState.value.pendingDelete ?: return
        _uiState.update { it.copy(pendingDelete = null) }
        deleteShift(shift.id)
    }

    /** SH-167: the confirmation was cancelled: the shift stays. */
    fun cancelDelete() {
        _uiState.update { it.copy(pendingDelete = null) }
    }

    /** Building the month (assigning, adding, editing shifts): not once the plan ended (SH-65). */
    private val canBuild: Boolean get() = _uiState.value.capabilities.shows(Gate.ROSTER_EDITING)

    fun startAssigning(shiftId: String?) {
        if (shiftId?.isPending == true || !canBuild) return
        _uiState.update { it.copy(assigningShiftId = shiftId) }
    }

    /**
     * Assigns [userId] with the soft validation (availability, overlaps, SH-47 checks); a conflict
     * asks first. SH-169: [undo] is the grid edit this finishes (offered once saved), [revert] what
     * cancelling the conflict puts back.
     */
    fun assignShift(shiftId: String, userId: String, force: Boolean = false, undo: GridUndo? = null, revert: GridUndo? = null) {
        if (shiftId.isPending || !canBuild) return
        val name = nameFor(userId)
        // SH-267: someone borrowed from another workplace of the group (null: the team's own).
        val borrowedFrom = borrowedFromFor(userId)
        // Shown at once; a conflict (soft validation) or an error undoes only this shift.
        val token = edit(shiftId) { it.copy(userId = userId, userDisplayName = name, isOpen = false, borrowedFromWorkplaceId = borrowedFrom) }
        _uiState.update { it.copy(pendingConflict = null, assigningShiftId = null) }
        viewModelScope.launch {
            assignUserToShiftUseCase(shiftId, userId, force, borrowedFrom).fold(
                onSuccess = { result ->
                    when (result) {
                        is AssignUserToShiftUseCase.AssignmentResult.Success -> {
                            saved(shiftId, token)
                            undo?.let(::offerGridUndo)
                        }
                        is AssignUserToShiftUseCase.AssignmentResult.ConflictFound -> {
                            undo(shiftId, token)
                            _uiState.update {
                                it.copy(pendingConflict = AssignmentConflict(shiftId, userId, result, undo = undo, revert = revert))
                            }
                        }
                    }
                },
                onFailure = { e ->
                    undo(shiftId, token, e)
                    revert?.let { restore(it.before) }
                }
            )
        }
    }

    fun unassignShift(shiftId: String) {
        if (shiftId.isPending || !canBuild) return
        val token = edit(shiftId) { it.copy(userId = null, userDisplayName = null) }
        viewModelScope.launch {
            unassignShiftFromEmployeeUseCase(shiftId).fold(
                onSuccess = { saved(shiftId, token) },
                onFailure = { e -> undo(shiftId, token, e) }
            )
        }
    }

    fun cancelConflict() {
        val revert = _uiState.value.pendingConflict?.revert
        _uiState.update { it.copy(pendingConflict = null) }
        // SH-169: a shift dragged to another day goes back where it was.
        revert?.let { restore(it.before) }
    }

    /**
     * A new shift from [template] on [date], for [userId] or open. Someone whose medical exam or
     * OHS training has expired by then is checked first, as assigning an existing shift is
     * (SH-47): a warning with "assign anyway" ([force]), or a refusal when the workplace blocks.
     */
    fun createShiftFromTemplate(date: LocalDate, template: ShiftTemplate, userId: String? = null, force: Boolean = false) {
        if (!canBuild) return
        val expired = userId?.let { _uiState.value.readinessByUserId[it]?.expiredOn(date) }.orEmpty()
        val blocked = _uiState.value.blockExpiredStaffChecks
        if (userId != null && expired.isNotEmpty() && (blocked || !force)) {
            val details = AssignUserToShiftUseCase.AssignmentResult.ConflictFound(
                conflictType = ConflictType.EXPIRED_STAFF_CHECK,
                employeeName = _uiState.value.availableEmployees.find { it.uid == userId }?.displayName,
                expiredChecks = expired,
                blocked = blocked
            )
            _uiState.update { it.copy(pendingConflict = AssignmentConflict("", userId, details, newShift = date to template)) }
            return
        }
        _uiState.update { it.copy(pendingConflict = null) }
        viewModelScope.launch {
            val shift = ShiftFactory.fromTemplate(
                rosterId = rosterId,
                date = date,
                template = template,
                createdBy = currentUserId(),
                userId = userId,
                userDisplayName = nameFor(userId)
            ).copy(borrowedFromWorkplaceId = borrowedFromFor(userId))
            // A placeholder id until the repository returns the real one.
            val pendingId = "$PENDING_ID_PREFIX${++editCounter}-${template.id}-$date"
            unsavedNew[pendingId] = shift.copy(id = pendingId)
            publishShifts()
            createShiftUseCase(shift).fold(
                onSuccess = { id ->
                    unsavedNew.remove(pendingId)
                    if (stored.none { it.id == id }) stored = stored + shift.copy(id = id)
                    publishShifts()
                    refreshShifts()
                },
                onFailure = { e ->
                    unsavedNew.remove(pendingId)
                    publishShifts()
                    _uiState.update { it.copy(error = e.toUiText()) }
                }
            )
        }
    }

    /**
     * SH-204: the "Add shift" dialog's shifts on [date] (a template tapped, several ticked, custom
     * times), for [userId] or nobody, in one batched write with one Undo ("Shifts added: n"), shown
     * at once. Someone whose medical exam or OHS training has expired by then is asked about first
     * for one shift (as [createShiftFromTemplate] does) and left out of several (as the grid does).
     */
    fun addShiftsToDay(date: LocalDate, templates: List<ShiftTemplate>, userId: String? = null) {
        val state = _uiState.value
        if (!canBuild || !state.canEditShifts || templates.isEmpty()) return
        if (userId != null && state.readinessByUserId[userId]?.expiredOn(date).orEmpty().isNotEmpty()) {
            if (templates.size == 1) createShiftFromTemplate(date, templates.single(), userId)
            else _uiState.update { it.copy(notice = UiText.Resource(Res.string.roster_cells_skipped, listOf(templates.size))) }
            return
        }
        viewModelScope.launch {
            val createdBy = currentUserId()
            val name = nameFor(userId)
            val borrowedFrom = borrowedFromFor(userId)
            val shifts = templates.map { template ->
                ShiftFactory.fromTemplate(rosterId, date, template, createdBy, userId, name).copy(borrowedFromWorkplaceId = borrowedFrom)
            }
            val placeholders = shifts.mapIndexed { i, shift -> shift.copy(id = "${PENDING_ID_PREFIX}day-${++editCounter}-$i") }
            placeholders.forEach { unsavedNew[it.id] = it }
            publishShifts()
            createShiftUseCase.many(shifts).fold(
                onSuccess = { ids ->
                    placeholders.forEach { unsavedNew.remove(it.id) }
                    val have = stored.map { it.id }.toSet()
                    stored = stored + placeholders.zip(ids).filter { (_, id) -> id !in have }.map { (p, id) -> p.copy(id = id) }
                    publishShifts()
                    offerGridUndo(GridUndo(GridEditKind.ADDED, createdIds = ids))
                    refreshShifts()
                },
                onFailure = { e ->
                    placeholders.forEach { unsavedNew.remove(it.id) }
                    publishShifts()
                    _uiState.update { it.copy(error = e.toUiText()) }
                }
            )
        }
    }

    private fun allShifts(): List<Shift> = _uiState.value.shiftsByDate.values.flatten()

    /**
     * What the grid shows: the stored shifts with the unsaved changes on top, and new ones not saved
     * yet. The same shifts as shown already (a save confirming what was shown) keep the shown map,
     * so the month's warnings are not worked out again (SH-158).
     */
    private fun publishShifts() {
        val shown = stored.map { shift -> unsaved[shift.id]?.change?.invoke(shift) ?: shift } + unsavedNew.values
        val byDate = byDate(shown)
        _uiState.update { state ->
            if (byDate == state.shiftsByDate) state else state.copy(shiftsByDate = byDate)
        }
    }

    /** The grid's days in order, each day's shifts by start time (sorted per day, not the whole month). */
    private fun byDate(shifts: List<Shift>): Map<LocalDate, List<Shift>> =
        shifts.groupBy { it.date }.entries.sortedBy { it.key }
            .associate { (date, day) -> LocalDate.parse(date) to day.sortedBy { it.plannedTime.start } }

    /** The same shifts, in any order (matched by id only when the order differs). */
    private fun sameShifts(a: List<Shift>, b: List<Shift>): Boolean =
        a.size == b.size && (a == b || a.associateBy { it.id } == b.associateBy { it.id })

    /** Shows [change] on [shiftId] until it is saved or undone; returns its token. */
    private fun edit(shiftId: String, change: (Shift) -> Shift): Long {
        val token = ++editCounter
        // A change on top of one still saving keeps both (the newer applies last).
        val earlier = unsaved[shiftId]?.change
        unsaved[shiftId] = UnsavedEdit(token) { shift -> change(earlier?.invoke(shift) ?: shift) }
        publishShifts()
        return token
    }

    /** [token]'s change is saved: it becomes part of the stored shift until the listener confirms it. */
    private fun saved(shiftId: String, token: Long) {
        settle(shiftId, token, ok = true)
        publishShifts()
        refreshShifts()
    }

    /** [token]'s change was not saved: only this shift goes back (a newer change on it stays). */
    private fun undo(shiftId: String, token: Long, e: Throwable? = null) {
        settle(shiftId, token, ok = false)
        publishShifts()
        e?.let { error -> _uiState.update { it.copy(error = error.toUiText()) } }
    }

    private fun settle(shiftId: String, token: Long, ok: Boolean) {
        val edit = unsaved[shiftId]?.takeIf { it.token == token } ?: return
        if (ok) stored = stored.map { if (it.id == shiftId) edit.change(it) else it }
        unsaved.remove(shiftId)
    }

    /**
     * After a save: the live listener brings the shifts; conflicts, the staffing hints and the
     * budget are read again ([scheduleDerived]). A listener that ended meanwhile is started again.
     */
    private fun refreshShifts() {
        if (liveShiftsEnded) observeShifts()
        scheduleDerived()
    }

    private var derivedRunning = false
    private var derivedAgain = false

    /**
     * Works the month's derived figures out again: conflicts (read from the server), the staffing
     * hints and the budget. Debounced: a pass waits [DERIVED_DEBOUNCE_MS] for the next change, so a
     * burst of them (a pasted week, a listener catching up) is worked out once; changes landing
     * during the pass get one more after it, never one per change.
     */
    private fun scheduleDerived() {
        if (derivedRunning) {
            derivedAgain = true
            return
        }
        derivedRunning = true
        viewModelScope.launch {
            try {
                do {
                    delay(DERIVED_DEBOUNCE_MS)
                    derivedAgain = false
                    withContext(compute) { detectRosterConflictsUseCase(rosterId) }.getOrNull()?.shiftsWithConflicts?.toSet()?.let { found ->
                        // The same conflicts keep the shown set (the cells compare it).
                        _uiState.update { if (it.conflictingShiftIds == found) it else it.copy(conflictingShiftIds = found) }
                    }
                    loadStaffing()
                    loadBudget()
                } while (derivedAgain)
            } finally {
                derivedRunning = false
            }
        }
    }

    private suspend fun currentUserId(): String = getCurrentUserUseCase().first()?.uid ?: "MANAGER"

    // --- SH-236: who actually worked, splitting a shift --------------------------------------------

    /** Whether "Who worked…" is offered for [shift]: a day up to today, by those who build the month. */
    fun mayRecordActualWork(shift: Shift): Boolean =
        recordActualWork != null && canBuild && !shift.id.isPending && shift.date <= today().toString()

    /** Whether "Split shift…" and "Undo split" are offered for [shift] (also ahead: a planned split). */
    fun maySplit(shift: Shift): Boolean =
        splitShiftUseCase != null && undoShiftSplit != null && canBuild && _uiState.value.canEditShifts && !shift.id.isPending

    /** Today (ISO), for the split dialog (a later day is a planned split). */
    val todayIso: String get() = today().toString()

    /**
     * A person's name for the dialogs and lines: the team's, else from their profile (SH-235's
     * resolver: people from other workplaces or who left, [refreshTeamFor]), else as the shifts
     * carry it; SH-237: null when nobody could name them (the screen shows its label, never the id).
     */
    fun nameOf(uid: String): String? =
        (_uiState.value.availableEmployees.firstOrNull { it.uid == uid }?.displayName?.takeIf { it.isNotBlank() }
            ?: otherNames[uid]
            ?: allShifts().firstOrNull { it.userId == uid && !it.userDisplayName.isNullOrBlank() }?.userDisplayName)
            ?.takeIf { it.isNotBlank() }

    /**
     * SH-236: who actually worked [shiftId] (optimistic like the grid's edits); the cost and the
     * day's figures follow from the recalculation.
     */
    fun recordActualWork(
        shiftId: String,
        worker: com.evoapps.evoshift.domain.model.ActualWorker,
        actual: TimeRange?,
        absenceType: com.evoapps.evoshift.domain.model.AbsenceType? = null
    ) {
        val useCase = recordActualWork ?: return
        val shift = allShifts().firstOrNull { it.id == shiftId } ?: return
        if (!mayRecordActualWork(shift)) return
        val nobody = worker is com.evoapps.evoshift.domain.model.ActualWorker.Nobody
        val token = edit(shiftId) {
            it.copy(
                actualUserId = (worker as? com.evoapps.evoshift.domain.model.ActualWorker.Person)?.userId?.takeIf { id -> id != it.userId },
                notWorked = nobody,
                noShowReason = (worker as? com.evoapps.evoshift.domain.model.ActualWorker.Nobody)?.reason,
                actualTime = if (nobody) null else actual ?: it.actualTime ?: it.plannedTime
            )
        }
        _uiState.update { it.copy(editingShift = null) }
        viewModelScope.launch {
            useCase(RosterIds.workplaceIdOf(rosterId), rosterId, shiftId, worker, actual, currentUserId(), absenceType).fold(
                onSuccess = { outcome ->
                    saved(shiftId, token)
                    val worked = outcome.shift.actualUserId
                    _uiState.update {
                        it.copy(
                            notice = when {
                                nobody && outcome.absenceRecorded == false -> UiText.Resource(Res.string.actual_work_absence_failed)
                                nobody && outcome.absenceRecorded == true -> UiText.Resource(Res.string.actual_work_saved_absence)
                                nobody -> UiText.Resource(Res.string.actual_work_saved_nobody)
                                worked == null -> UiText.Resource(Res.string.actual_work_saved_planned)
                                else -> UiText.Resource(Res.string.who_worked_recorded, com.evoapps.evoshift.ui.util.personNameArg(nameOf(worked)))
                            }
                        )
                    }
                },
                onFailure = { e -> undo(shiftId, token, e) }
            )
        }
    }

    /**
     * SH-236: [shiftId] split at [handoverAt] for [replacementId]: both parts show at once (the
     * second under a placeholder id until it is written); a refusal puts the shift back.
     */
    fun splitShift(shiftId: String, handoverAt: String, replacementId: String, reason: String?, sickness: Boolean, recordSickLeave: Boolean) {
        val useCase = splitShiftUseCase ?: return
        val shift = allShifts().firstOrNull { it.id == shiftId } ?: return
        if (!maySplit(shift)) return
        val todayIso = todayIso
        val name = nameOf(replacementId)
        viewModelScope.launch {
            val editor = currentUserId()
            val parts = runCatching {
                com.evoapps.evoshift.domain.model.ShiftSplits.split(
                    shift, handoverAt, replacementId, name, reason, sickness, editor,
                    com.evoapps.evoshift.domain.util.AppClock.now().toString(), planned = shift.date > todayIso
                )
            }.getOrElse { e ->
                _uiState.update { it.copy(error = e.toUiText()) }
                return@launch
            }
            val token = edit(shiftId) { parts.first }
            val pendingId = PENDING_ID_PREFIX + "split-" + (++editCounter) + "-" + shiftId
            unsavedNew[pendingId] = parts.second.copy(id = pendingId)
            publishShifts()
            _uiState.update { it.copy(editingShift = null) }
            useCase(RosterIds.workplaceIdOf(rosterId), rosterId, shiftId, handoverAt, replacementId, reason, sickness, recordSickLeave, editor, todayIso).fold(
                onSuccess = { outcome ->
                    unsavedNew.remove(pendingId)
                    if (stored.none { it.id == outcome.second.id }) stored = stored + outcome.second
                    saved(shiftId, token)
                    _uiState.update {
                        it.copy(
                            notice = if (outcome.absenceRecorded == false) UiText.Resource(Res.string.split_absence_failed)
                            else UiText.Resource(Res.string.split_done, com.evoapps.evoshift.ui.util.personNameArg(name), handoverAt.substringAfter('T').take(5))
                        )
                    }
                },
                onFailure = { e ->
                    unsavedNew.remove(pendingId)
                    undo(shiftId, token, e)
                }
            )
        }
    }

    /** SH-236: the split of [shiftId] (either part) undone: whole again at once, back on a refusal. */
    fun undoSplit(shiftId: String) {
        val useCase = undoShiftSplit ?: return
        val shifts = allShifts()
        val shift = shifts.firstOrNull { it.id == shiftId } ?: return
        val split = shift.split ?: return
        if (!maySplit(shift)) return
        val first = if (split.isFirst) shift else shifts.firstOrNull { it.id == split.groupId }
        val second = first?.let { com.evoapps.evoshift.domain.model.ShiftSplits.otherPart(it, shifts) }
        _uiState.update { it.copy(editingShift = null) }
        viewModelScope.launch {
            val editor = currentUserId()
            val removed = second?.let { s -> stored.firstOrNull { it.id == s.id } }
            val token = if (first != null && second != null) {
                val restored = com.evoapps.evoshift.domain.model.ShiftSplits.undo(first, second, editor, com.evoapps.evoshift.domain.util.AppClock.now().toString())
                stored = stored.filterNot { it.id == second.id }
                edit(first.id) { restored }
            } else null
            useCase(RosterIds.workplaceIdOf(rosterId), rosterId, shiftId, editor).fold(
                onSuccess = { outcome ->
                    stored = stored.filterNot { it.id == outcome.removedId }
                    if (token != null && first != null) saved(first.id, token) else refreshShifts()
                    _uiState.update { it.copy(notice = UiText.Resource(Res.string.split_undone)) }
                },
                onFailure = { e ->
                    if (removed != null && stored.none { it.id == removed.id }) stored = stored + removed
                    if (token != null && first != null) undo(first.id, token, e)
                    else _uiState.update { it.copy(error = e.toUiText()) }
                }
            )
        }
    }

    /**
     * Unassigned shifts not marked open would be removed by publishing: ask first. Open shifts
     * alone need no confirmation, they are what the manager chose.
     */
    fun onPublishClicked() {
        if (!_uiState.value.capabilities.shows(Gate.PUBLISH_ROSTER)) return
        val unassigned = _uiState.value.shiftsByDate.values.flatten().filter { it.userId == null }
        val leftovers = unassigned.count { !it.isOpen }
        if (leftovers > 0) {
            _uiState.update { it.copy(publishConfirmation = PublishConfirmation(leftovers, unassigned.size - leftovers)) }
        } else {
            publishRoster()
        }
    }

    /** Publishes; with [markLeftoversOpen] the unassigned shifts are offered to the team instead of removed. */
    fun confirmPublish(markLeftoversOpen: Boolean = false) {
        if (!_uiState.value.capabilities.shows(Gate.PUBLISH_ROSTER)) return
        _uiState.update { it.copy(publishConfirmation = null) }
        publishRoster(
            leftoverIdsToOpen = if (markLeftoversOpen) {
                _uiState.value.shiftsByDate.values.flatten().filter { it.userId == null && !it.isOpen }.map { it.id }
            } else {
                emptyList()
            }
        )
    }

    fun cancelPublish() {
        _uiState.update { it.copy(publishConfirmation = null) }
    }

    /**
     * Publishing writes the whole month: it shows progress (isPublishing) and runs in the app's
     * saves (SH-148), so leaving the screen (which clears this view model) cannot stop it halfway
     * with the roster still a draft; the top bar shows it and a month opened again follows it.
     */
    private fun publishRoster(leftoverIdsToOpen: List<String> = emptyList()) {
        val currentState = _uiState.value
        val roster = currentState.roster ?: return
        if (currentState.isPublishing || saves.isPending(publishKey)) return
        val openedIds = leftoverIdsToOpen.toSet()
        val allShifts = currentState.shiftsByDate.values.flatten()
            .map { if (it.id in openedIds) it.copy(isOpen = true) else it }
        // Publishing removes unassigned shifts that are not open: the summary counts what stays.
        val assigned = allShifts.filter { it.userId != null }
        val open = allShifts.count { it.userId == null && it.isOpen }
        val totalHours = assigned.sumOf { calculateDurationHours(it.plannedTime.start, it.plannedTime.end) }

        _uiState.update { it.copy(isPublishing = true) }
        viewModelScope.launch {
            val result = saves.run(publishKey, successMessage = UiText.Resource(Res.string.roster_published)) {
                runCatching {
                    val publisher = currentUserId()
                    if (openedIds.isNotEmpty()) markShiftsOpenUseCase(openedIds, publisher).getOrThrow()
                    publishRosterUseCase(rosterId, publisher).getOrThrow()
                }
            }
            result
                .onSuccess {
                    AppTelemetry.log(AnalyticsEvent.RosterPublished)
                    // SH-240: a success moment for the store rating prompt.
                    com.evoapps.evoshift.review.AppReviewPrompt.onSuccess(com.evoapps.evoshift.domain.review.SuccessMoment.ROSTER_PUBLISHED, roster.workplaceId)
                    _uiState.update {
                        it.copy(
                            isPublishing = false,
                            publishSuccessData = PublishSuccessData(
                                month = roster.month,
                                year = roster.year,
                                totalHours = totalHours,
                                totalShifts = assigned.size + open,
                                filledShifts = assigned.size,
                                openShifts = open
                            )
                        )
                    }
                    loadData()
                }
                .onFailure { e ->
                    _uiState.update { it.copy(isPublishing = false, error = e.toUiText()) }
                    refreshShifts()
                }
        }
    }

    fun dismissPublishSuccess() {
        _uiState.update { it.copy(publishSuccessData = null) }
    }

    fun onShiftClicked(shift: Shift) {
        if (shift.id.isPending || !canBuild) return
        _uiState.update { it.copy(editingShift = shift) }
    }

    fun onDismissEdit() {
        _uiState.update { it.copy(editingShift = null) }
    }

    /** Whether the screen offers deleting shifts: the use case bound (the state says whether the month allows it). */
    val deleteAvailable: Boolean get() = deleteShiftUseCase != null

    /**
     * Removes the shift from the month (the screen asked first). Shown at once; a failed delete puts
     * it back. Its cost snapshot and note go with it on the server (onShiftDeleted), so the labour
     * cost and the budget follow on the refresh.
     */
    fun deleteShift(shiftId: String) {
        val delete = deleteShiftUseCase ?: return
        if (shiftId.isPending || !_uiState.value.canEditShifts) return
        val removed = stored.firstOrNull { it.id == shiftId } ?: return
        // Gone at once; a failed delete brings back only this shift.
        stored = stored.filterNot { it.id == shiftId }
        unsaved.remove(shiftId)
        publishShifts()
        _uiState.update {
            it.copy(
                editingShift = it.editingShift?.takeIf { e -> e.id != shiftId }, assigningShiftId = null,
                pickerShiftId = it.pickerShiftId?.takeIf { p -> p != shiftId }
            )
        }
        viewModelScope.launch {
            delete(shiftId).fold(
                onSuccess = {
                    // SH-158: "Shift deleted." with Undo (createShiftUseCase can put it back).
                    _uiState.update { it.copy(deleteUndo = DeleteUndo(removed), gridUndo = null, copyUndo = null) }
                    refreshShifts()
                },
                onFailure = { e ->
                    if (stored.none { it.id == shiftId }) stored = stored + removed
                    publishShifts()
                    _uiState.update { it.copy(error = e.toUiText()) }
                }
            )
        }
    }

    /**
     * Saves the edit dialog. Changing who works the shift goes through the same soft validation
     * as assigning from the grid (availability, overlaps), so a conflict is shown, not saved silently.
     */
    fun updateShift(
        shiftId: String,
        userId: String?,
        requiredRole: String?,
        requiredSkills: List<String>,
        plannedTime: TimeRange,
        actualTime: TimeRange?,
        isOpen: Boolean = false,
        /** SH-116: the corrected breaks; null keeps them. */
        breaks: List<ShiftBreak>? = null
    ) {
        if (!canBuild) return
        val current = allShifts().firstOrNull { it.id == shiftId }
        val reassigned = userId != null && userId != current?.userId
        // Times and role are saved first, keeping the current person; the new person then goes
        // through the assignment's checks (as from the grid). The grid shows the new person at once.
        val keptUserId = if (reassigned) current?.userId else userId
        val keptName = _uiState.value.availableEmployees.find { it.uid == keptUserId }?.displayName
        val newName = _uiState.value.availableEmployees.find { it.uid == userId }?.displayName
        val times = { s: Shift ->
            s.copy(
                requiredRole = requiredRole, requiredSkills = requiredSkills, plannedTime = plannedTime, actualTime = actualTime,
                breaks = if (actualTime?.start.isNullOrEmpty()) emptyList() else breaks ?: s.breaks
            )
        }
        val token = edit(shiftId) { times(it).copy(userId = userId, userDisplayName = newName, isOpen = isOpen && userId == null) }
        onDismissEdit()
        viewModelScope.launch {
            updateShiftUseCase(
                shiftId = shiftId,
                userId = keptUserId,
                userDisplayName = keptName,
                requiredRole = requiredRole,
                requiredSkills = requiredSkills,
                plannedTime = plannedTime,
                actualTime = actualTime,
                editorUserId = currentUserId(),
                isOpen = isOpen,
                breaks = breaks
            ).fold(
                onSuccess = {
                    if (reassigned) {
                        // The times are saved; the new person is shown until the assignment settles.
                        if (unsaved[shiftId]?.token == token) {
                            stored = stored.map { if (it.id == shiftId) times(it).copy(userId = keptUserId, userDisplayName = keptName) else it }
                        }
                        assignShift(shiftId, userId!!)
                    } else saved(shiftId, token)
                },
                onFailure = { e -> undo(shiftId, token, e) }
            )
        }
    }

    // --- SH-169: the desktop grid (keyboard, drag and drop, multi-select, copy and paste) -------

    /** SH-169: the grid's edit is saved: its snackbar offers Undo (one Undo at a time). */
    private fun offerGridUndo(undo: GridUndo) {
        _uiState.update { it.copy(gridUndo = undo, deleteUndo = null, copyUndo = null) }
    }

    /**
     * SH-169: Delete on a cell: its shifts lose their person and stay in the month as unassigned
     * shifts (as the right-click menu's "Unassign" does); Undo gives them back.
     */
    fun unassignShifts(shiftIds: List<String>) {
        if (!canBuild) return
        val before = allShifts().filter { it.id in shiftIds && it.userId != null && !it.id.isPending }
        if (before.isEmpty()) return
        before.forEach { unassignShift(it.id) }
        offerGridUndo(GridUndo(GridEditKind.UNASSIGNED, before = before))
    }

    /**
     * SH-169: a shift chip dropped on another cell: to another person the same day (reassigned) or
     * to another day of the month (moved, the same times on that day), or both. The person goes
     * through the same soft validation as assigning: a conflict asks, and cancelling it puts the
     * shift back where it was. A shift already clocked in stays where it is.
     */
    fun moveShift(shiftId: String, toUserId: String, toDate: LocalDate) {
        if (shiftId.isPending || !canBuild) return
        val shift = allShifts().firstOrNull { it.id == shiftId } ?: return
        val fromDate = LocalDate.parse(shift.date)
        if (shift.userId == toUserId && fromDate == toDate) return
        if (!shift.actualTime?.start.isNullOrEmpty()) {
            _uiState.update { it.copy(notice = UiText.Resource(Res.string.roster_move_started)) }
            return
        }
        val undo = GridUndo(GridEditKind.MOVED, before = listOf(shift))
        if (fromDate == toDate) {
            assignShift(shiftId, toUserId, undo = undo)
            return
        }
        // Another day: the times move with it (an overnight shift ends the next morning again).
        val planned = plannedTimeRange(toDate, shift.plannedTime.start.substring(11, 16), shift.plannedTime.end.substring(11, 16))
        val moved = { s: Shift ->
            s.copy(date = toDate.toString(), dailyRecordId = DailyRecordIds.of(RosterIds.workplaceIdOf(s.rosterId), toDate.toString()), plannedTime = planned)
        }
        val name = nameFor(toUserId)
        val token = edit(shiftId) { moved(it).copy(userId = toUserId, userDisplayName = name, isOpen = false, borrowedFromWorkplaceId = borrowedFromFor(toUserId)) }
        viewModelScope.launch {
            // The new day first, without the person; then the person through the assignment's checks.
            updateShiftUseCase(
                shiftId = shiftId, userId = null, userDisplayName = null,
                requiredRole = shift.requiredRole, requiredSkills = shift.requiredSkills,
                plannedTime = planned, actualTime = shift.actualTime, editorUserId = currentUserId(),
                date = toDate
            ).fold(
                onSuccess = {
                    if (unsaved[shiftId]?.token == token) {
                        stored = stored.map { if (it.id == shiftId) moved(it).copy(userId = null, userDisplayName = null) else it }
                    }
                    assignShift(shiftId, toUserId, undo = undo, revert = undo)
                },
                onFailure = { e -> undo(shiftId, token, e) }
            )
        }
    }

    /**
     * SH-169: a shift template on several selected cells (Shift/Ctrl/Cmd+click) in one batched
     * write, with one Undo. Someone whose medical exam or OHS training has expired by the day is
     * left out (the snackbar says how many); the grid's warnings mark the rest as usual.
     */
    fun applyTemplateToCells(cells: List<GridCell>, template: ShiftTemplate) {
        createInCells(cells, listOf(template))
    }

    /** SH-169: Ctrl/Cmd+C on a cell: its shifts' times and requirements, to paste on other cells. */
    fun copyCell(cell: GridCell) {
        val shifts = _uiState.value.shiftsByUserAndDate[cell.userId]?.get(cell.date).orEmpty()
        if (shifts.isEmpty()) return
        val copied = shifts.map {
            CopiedShift(it.plannedTime.start.substring(11, 16), it.plannedTime.end.substring(11, 16), it.requiredRole, it.requiredSkills)
        }
        _uiState.update { it.copy(copiedShifts = copied, notice = UiText.Resource(Res.string.roster_cell_copied, listOf(copied.size))) }
    }

    /** SH-169: Ctrl/Cmd+V: the copied shifts created on [cells] (the focused cell or the selection), one Undo. */
    fun pasteCells(cells: List<GridCell>) {
        val copied = _uiState.value.copiedShifts ?: return
        createInCells(cells, copied.map { it.asTemplate() })
    }

    private fun createInCells(cells: List<GridCell>, templates: List<ShiftTemplate>) {
        if (!canBuild || cells.isEmpty() || templates.isEmpty()) return
        val state = _uiState.value
        val (left, kept) = cells.distinct().partition { cell -> state.readinessByUserId[cell.userId]?.expiredOn(cell.date).orEmpty().isNotEmpty() }
        if (kept.isEmpty()) {
            _uiState.update { it.copy(notice = UiText.Resource(Res.string.roster_cells_skipped, listOf(left.size))) }
            return
        }
        viewModelScope.launch {
            val createdBy = currentUserId()
            val shifts = kept.flatMap { cell ->
                val name = nameFor(cell.userId)
                val borrowedFrom = borrowedFromFor(cell.userId)
                templates.map { template ->
                    ShiftFactory.fromTemplate(rosterId, cell.date, template, createdBy, cell.userId, name).copy(borrowedFromWorkplaceId = borrowedFrom)
                }
            }
            val placeholders = shifts.mapIndexed { i, shift -> shift.copy(id = "${PENDING_ID_PREFIX}cells-${++editCounter}-$i") }
            placeholders.forEach { unsavedNew[it.id] = it }
            publishShifts()
            createShiftUseCase.many(shifts).fold(
                onSuccess = { ids ->
                    placeholders.forEach { unsavedNew.remove(it.id) }
                    val have = stored.map { it.id }.toSet()
                    stored = stored + placeholders.zip(ids).filter { (_, id) -> id !in have }.map { (p, id) -> p.copy(id = id) }
                    publishShifts()
                    offerGridUndo(GridUndo(GridEditKind.ADDED, createdIds = ids))
                    if (left.isNotEmpty()) _uiState.update { it.copy(notice = UiText.Resource(Res.string.roster_cells_skipped, listOf(left.size))) }
                    refreshShifts()
                },
                onFailure = { e ->
                    placeholders.forEach { unsavedNew.remove(it.id) }
                    publishShifts()
                    _uiState.update { it.copy(error = e.toUiText()) }
                }
            )
        }
    }

    /** SH-169: Ctrl/Cmd+Z: the newest Undo on offer (the grid's edit, a deleted shift or a copy). */
    fun undoLast(): Boolean {
        val state = _uiState.value
        when {
            state.gridUndo != null -> undoGrid()
            state.deleteUndo != null -> undoDelete()
            state.copyUndo != null -> undoCopy()
            else -> return false
        }
        return true
    }

    /** SH-169: puts the grid's last edit back: the shifts as they were, the new ones removed. */
    fun undoGrid() {
        val undo = _uiState.value.gridUndo ?: return
        _uiState.update { it.copy(gridUndo = null) }
        if (!canBuild) return
        restore(undo.before)
        if (undo.createdIds.isNotEmpty()) removeCreated(undo.createdIds)
        _uiState.update { it.copy(notice = UiText.Resource(Res.string.roster_grid_undone)) }
    }

    /** SH-169: the grid's undo snackbar is gone: the edit stays. */
    fun dismissGridUndo() {
        _uiState.update { it.copy(gridUndo = null) }
    }

    /** The shifts of [before] saved as they were (person, day, times), without the assignment's checks: they were so. */
    private fun restore(before: List<Shift>) {
        before.forEach { was ->
            val token = edit(was.id) { now ->
                now.copy(
                    userId = was.userId, userDisplayName = was.userDisplayName, isOpen = was.isOpen, date = was.date,
                    dailyRecordId = was.dailyRecordId, plannedTime = was.plannedTime,
                    requiredRole = was.requiredRole, requiredSkills = was.requiredSkills
                )
            }
            viewModelScope.launch {
                updateShiftUseCase(
                    shiftId = was.id, userId = was.userId, userDisplayName = was.userDisplayName,
                    requiredRole = was.requiredRole, requiredSkills = was.requiredSkills,
                    plannedTime = was.plannedTime, actualTime = was.actualTime, editorUserId = currentUserId(),
                    isOpen = was.isOpen, date = LocalDate.parse(was.date)
                ).fold(
                    onSuccess = { saved(was.id, token) },
                    onFailure = { e -> undo(was.id, token, e) }
                )
            }
        }
    }

    private fun removeCreated(ids: List<String>) {
        val delete = deleteShiftUseCase ?: return
        val removed = stored.filter { it.id in ids }
        stored = stored.filter { it.id !in ids }
        publishShifts()
        viewModelScope.launch {
            delete.many(ids).fold(
                onSuccess = { refreshShifts() },
                onFailure = { e ->
                    stored = stored + removed.filter { r -> stored.none { it.id == r.id } }
                    publishShifts()
                    _uiState.update { it.copy(error = e.toUiText()) }
                }
            )
        }
    }

    /** SH-169: Ctrl+scroll and Ctrl +/-: the grid's cells wider or narrower by [steps], kept on this device. */
    fun zoomGrid(steps: Int) = setGridZoom(_uiState.value.gridZoom + steps * GRID_ZOOM_STEP)

    /** SH-169: Ctrl+0: the grid's own width again. */
    fun resetGridZoom() = setGridZoom(1f)

    private fun setGridZoom(zoom: Float) {
        // Whole tenths, so steps in and out land on the same widths.
        val next = kotlin.math.round(zoom.coerceIn(GRID_ZOOM_MIN, GRID_ZOOM_MAX) * 10f) / 10f
        if (next == _uiState.value.gridZoom) return
        _uiState.update { it.copy(gridZoom = next) }
        localSettings?.putString(GRID_ZOOM_KEY, if (next == 1f) null else next.toString())
    }

    // --- SH-53: auto-assign --------------------------------------------------------------------

    private val autoAssignJob = JobSlot()

    /** Whether the screen offers auto-assign: the use cases bound (the state says whether the month allows it). */
    val autoAssignAvailable: Boolean get() = planAutoSchedule != null && applyAutoSchedule != null

    /**
     * Works out who could take the month's unassigned shifts by the owner's rules (availability,
     * absences, role, overlaps across workplaces, rest, days in a row, contracted hours) and opens
     * the preview. Nothing is written until [applyAutoAssign].
     */
    fun onAutoAssignClicked() {
        val planner = planAutoSchedule ?: return
        val state = _uiState.value
        if (!state.canAutoAssign || applyAutoSchedule == null || state.autoAssign != null) return
        // Contracted hours cap and balance the plan only where pay terms are the person's to read.
        val readPayTerms = state.capabilities.shows(Gate.PAY_AND_PRIVATE_DATA)
        _uiState.update { it.copy(autoAssign = AutoAssignUiState(isPlanning = true, targetsNotUsed = !readPayTerms)) }
        checkAiOffered()
        // Closing and reopening the sheet starts over: an older plan never lands in the new sheet.
        autoAssignJob.launch(viewModelScope) {
            withContext(compute) { planner(rosterId, readPayTerms = readPayTerms) }.fold(
                onSuccess = { plan ->
                    _uiState.update { current ->
                        // Closed meanwhile: the preview is not wanted any more.
                        val open = current.autoAssign ?: return@update current
                        current.copy(
                            autoAssign = open.copy(
                                isPlanning = false,
                                plan = plan,
                                accepted = plan.assignments.map { it.shiftId }.toSet()
                            )
                        )
                    }
                },
                onFailure = { e -> _uiState.update { it.copy(autoAssign = null, error = e.toUiText()) } }
            )
        }
    }

    // --- SH-90: AI suggestions ------------------------------------------------------------------

    private val aiStatusJob = JobSlot()

    /**
     * Offers "Suggest with AI" only where the gate allows it (a manager, the plan running) and the
     * server says it is on (kill switch, set up, quota left). Any doubt: not offered.
     */
    private fun checkAiOffered() {
        val ai = suggestWithAi ?: return
        val state = _uiState.value
        val workplaceId = state.roster?.workplaceId ?: return
        if (!state.capabilities.shows(Gate.AI_AUTO_ASSIGN)) return
        aiStatusJob.launch(viewModelScope) {
            val offered = ai.status(workplaceId).getOrNull()?.enabled == true
            _uiState.update { current ->
                val sheet = current.autoAssign ?: return@update current
                current.copy(autoAssign = sheet.copy(aiOffered = offered))
            }
        }
    }

    /**
     * Plans again with AI suggestions: only pseudonymised data leaves the device, every proposal is
     * checked against the same hard rules and the rules fill the rest. When the AI is off, over
     * quota or fails, the rules' plan is shown with why. Nothing is written until [applyAutoAssign].
     */
    fun suggestAutoAssignWithAi() {
        val ai = suggestWithAi ?: return
        val state = _uiState.value
        val sheet = state.autoAssign ?: return
        if (!sheet.aiOffered || sheet.isPlanning || !state.canAutoAssign || !state.capabilities.shows(Gate.AI_AUTO_ASSIGN)) return
        val readPayTerms = state.capabilities.shows(Gate.PAY_AND_PRIVATE_DATA)
        aiStatusJob.launch(viewModelScope) {}
        _uiState.update {
            it.copy(autoAssign = AutoAssignUiState(isPlanning = true, targetsNotUsed = !readPayTerms, aiOffered = true, usedAi = true))
        }
        autoAssignJob.launch(viewModelScope) {
            withContext(compute) { ai(rosterId, readPayTerms = readPayTerms) }.fold(
                onSuccess = { result ->
                    AppTelemetry.log(AnalyticsEvent.AiShiftSuggestions(fellBack = result.fallback != null))
                    _uiState.update { current ->
                        val open = current.autoAssign ?: return@update current
                        current.copy(
                            autoAssign = open.copy(
                                isPlanning = false,
                                plan = result.plan,
                                accepted = result.plan.assignments.map { it.shiftId }.toSet(),
                                // Off, used up or not allowed: not offered again in this sheet.
                                aiOffered = result.fallback == null || result.fallback == AiAssignFailure.MODEL_FAILED ||
                                    result.fallback == AiAssignFailure.UNKNOWN,
                                aiFallback = result.fallback?.let(::aiFallbackText)
                            )
                        )
                    }
                },
                onFailure = { e -> _uiState.update { it.copy(autoAssign = null, error = e.toUiText()) } }
            )
        }
    }

    private fun aiFallbackText(failure: AiAssignFailure): UiText = UiText.Resource(
        when (failure) {
            AiAssignFailure.DISABLED -> Res.string.auto_assign_ai_fallback_disabled
            AiAssignFailure.QUOTA_EXCEEDED -> Res.string.auto_assign_ai_fallback_quota
            AiAssignFailure.PLAN_REQUIRED -> Res.string.auto_assign_ai_fallback_plan
            AiAssignFailure.NOT_ALLOWED -> Res.string.auto_assign_ai_fallback_not_allowed
            AiAssignFailure.TOO_LARGE -> Res.string.auto_assign_ai_fallback_too_large
            AiAssignFailure.INVALID_REQUEST, AiAssignFailure.MODEL_FAILED, AiAssignFailure.UNKNOWN -> Res.string.auto_assign_ai_fallback_failed
        }
    )

    /** Keeps or drops one proposal. */
    fun toggleAutoAssignment(shiftId: String) {
        _uiState.update { state ->
            val sheet = state.autoAssign ?: return@update state
            val accepted = if (shiftId in sheet.accepted) sheet.accepted - shiftId else sheet.accepted + shiftId
            state.copy(autoAssign = sheet.copy(accepted = accepted))
        }
    }

    /** Keeps every proposal, or none. */
    fun setAllAutoAssignments(accept: Boolean) {
        _uiState.update { state ->
            val sheet = state.autoAssign ?: return@update state
            val all = sheet.plan?.assignments?.map { it.shiftId }?.toSet().orEmpty()
            state.copy(autoAssign = sheet.copy(accepted = if (accept) all else emptySet()))
        }
    }

    fun dismissAutoAssign() {
        autoAssignJob.launch(viewModelScope) {}
        aiStatusJob.launch(viewModelScope) {}
        _uiState.update { it.copy(autoAssign = null) }
    }

    /**
     * Writes the kept proposals in one batch. Shown at once; a failure puts the grid back. A shift
     * someone assigned or changed since the preview is left as it is (ApplyAutoScheduleUseCase).
     */
    fun applyAutoAssign() {
        val apply = applyAutoSchedule ?: return
        val state = _uiState.value
        val sheet = state.autoAssign ?: return
        val plan = sheet.plan ?: return
        if (!state.canAutoAssign) return
        val kept = plan.assignments.filter { it.shiftId in sheet.accepted }
        _uiState.update { it.copy(autoAssign = null) }
        if (kept.isEmpty()) return
        val byShift = kept.associateBy { it.shiftId }
        // Only shifts still unassigned in the grid: what the manager assigned meanwhile stays.
        val open = allShifts().filter { it.userId == null }.map { it.id }.toSet()
        val tokens = byShift.filterKeys { it in open }.mapValues { (id, planned) ->
            edit(id) { shift -> if (shift.userId == null) shift.copy(userId = planned.userId, userDisplayName = planned.displayName, isOpen = false) else shift }
        }
        viewModelScope.launch {
            // SH-148: the batch finishes even if the screen is left; a second one waits for it.
            val editor = currentUserId()
            saves.run(autoAssignKey) { apply(plan, onlyShiftIds = byShift.keys, editorUserId = editor) }.fold(
                onSuccess = { applied ->
                    AppTelemetry.log(AnalyticsEvent.ShiftsAutoAssigned)
                    val notice = if (applied.skipped.isEmpty()) {
                        UiText.Resource(Res.string.auto_assign_applied, listOf(applied.assigned))
                    } else {
                        UiText.Resource(Res.string.auto_assign_skipped, listOf(applied.assigned, applied.skipped.size))
                    }
                    _uiState.update { it.copy(notice = notice) }
                    // Skipped ones go back; the listener confirms what was saved.
                    val skipped = applied.skipped.toSet()
                    tokens.forEach { (id, token) -> settle(id, token, ok = id !in skipped) }
                    publishShifts()
                    refreshShifts()
                },
                onFailure = { e ->
                    tokens.forEach { (id, token) -> settle(id, token, ok = false) }
                    publishShifts()
                    _uiState.update { it.copy(error = e.toUiText()) }
                }
            )
        }
    }

    // --- SH-205: the one "Copy shifts" tool (SH-114 weeks, SH-171 days, ranges) --------------

    private val copyJob = JobSlot()
    private val copyMonthJob = JobSlot()

    /** Whether the screen offers copying (the state says whether the month allows it). */
    val copyAvailable: Boolean get() = copyShifts != null

    /**
     * SH-215: "Copy shifts", the screen's one entry point (the top bar). With a day open (its pane
     * or sheet) that day is the source and the tool goes straight to where to; otherwise last week
     * is the source, pasted from the first week with a day of the month still without shifts (else
     * the month's first full week), with the preview.
     */
    fun onCopyClicked() {
        val state = _uiState.value
        val roster = state.roster ?: return
        state.selectedDate?.takeIf { it.year == roster.year && it.month.number == roster.month }?.let { day ->
            openCopyDays(setOf(day))
            return
        }
        val weeks = weeksOf(roster.year, roster.month, state.firstDayOfWeek)
        val target = weeks.firstOrNull { week ->
            (0 until 7).map { week.plus(DatePeriod(days = it)) }
                .any { it.year == roster.year && it.month.number == roster.month && state.shiftsByDate[it].isNullOrEmpty() }
        } ?: weeks.firstOrNull { it.day == 1 || it.month.number == roster.month } ?: weeks.first()
        // A week across the 1st starts on the 1st; its source is the seven days before, so weekdays match.
        val start = target.takeIf { it.year == roster.year && it.month.number == roster.month } ?: LocalDate(roster.year, roster.month, 1)
        val source = start.plus(DatePeriod(days = -7))
        openCopyTool((0 until 7).map { source.plus(DatePeriod(days = it)) }.toSet(), setOf(start), requireShifts = false)
    }

    /**
     * Opens the tool with [sources] copied (the open day, the headers' selection); with [starts]
     * (a paste onto day headers) it goes straight to their preview. Months that take copies only.
     */
    fun openCopyDays(sources: Set<LocalDate>, starts: Set<LocalDate> = emptySet()) {
        val roster = _uiState.value.roster ?: return
        val inMonth = sources.filter { it.year == roster.year && it.month.number == roster.month }.toSet()
        if (inMonth.isEmpty()) return
        openCopyTool(inMonth, starts, requireShifts = true)
    }

    /** Opens the tool on where to when [sources] have shifts (or a week is copied), else on where from. */
    private fun openCopyTool(sources: Set<LocalDate>, starts: Set<LocalDate>, requireShifts: Boolean) {
        val state = _uiState.value
        val roster = state.roster ?: return
        if (copyShifts == null || !state.canCopy || state.copyTool != null) return
        val first = sources.min()
        val sheet = CopyToolUiState(
            year = roster.year,
            month = roster.month,
            firstDayOfWeek = state.firstDayOfWeek,
            sources = sources,
            shownYear = first.year,
            shownMonth = first.month.number,
            shiftsOn = state.shiftsByDate.mapValues { it.value.size }.filterValues { it > 0 },
            closedDays = state.closedDays.keys
        )
        val validStarts = starts.filter { it in sheet.days }.toSet()
        val onTarget = !requireShifts || sheet.sourceShifts > 0
        updateCopyTool(
            if (!onTarget) sheet
            else sheet.copy(step = CopyToolStep.TARGET, starts = validStarts.ifEmpty { if (sheet.isSingleDay) emptySet() else setOfNotNull(sheet.defaultStart) })
        )
        loadCopyMonths(sources.map { it.year to it.month.number }.toSet())
    }

    fun copyToolTapSource(date: LocalDate) = editCopyTool { it.tapSource(date) }
    fun copyToolPickWeek(start: LocalDate) = editCopyTool { it.pickWeek(start) }

    /** "Whole previous month": last month by weekday onto the whole month (its shifts read for the calendar). */
    fun copyToolWholePreviousMonth() {
        editCopyTool { it.pickWholePreviousMonth() }
        val sheet = _uiState.value.copyTool ?: return
        loadCopyMonths(setOf(sheet.shownYear to sheet.shownMonth))
    }
    fun copyToolNext() = editCopyTool { it.next() }
    fun copyToolBack() = editCopyTool { it.back() }
    fun copyToolTapTarget(date: LocalDate) = editCopyTool { it.tapTarget(date) }
    fun copyToolToggleTargets(days: Set<LocalDate>) = editCopyTool { it.toggleTargets(days) }
    fun copyToolClearTargets() = editCopyTool { it.clearTargets() }
    fun copyToolRepeat(on: Boolean) = editCopyTool { it.withRepeat(on) }

    /** SH-199: Add, Replace or Skip for target days that already have shifts. */
    fun setCopyPlannedDays(mode: PlannedDaysMode) = editCopyTool { it.copy(plannedDays = mode) }

    /** The source calendar one month earlier or later (an earlier month's shifts are read for it). */
    fun copyToolShowMonth(delta: Int) {
        editCopyTool { it.showMonth(delta) }
        val sheet = _uiState.value.copyTool ?: return
        loadCopyMonths(setOf(sheet.shownYear to sheet.shownMonth))
    }

    /** Reads how many shifts each day of [months] (other than the roster's) has, for the source calendar. */
    private fun loadCopyMonths(months: Set<Pair<Int, Int>>) {
        val copy = copyShifts ?: return
        val roster = _uiState.value.roster ?: return
        val others = months.filter { it != roster.year to roster.month }
        val sheet = _uiState.value.copyTool ?: return
        val missing = others.filter { (y, m) -> sheet.shiftsOn.keys.none { it.year == y && it.month.number == m } }
        if (missing.isEmpty()) return
        _uiState.update { s -> s.copy(copyTool = s.copyTool?.copy(loadingMonth = true)) }
        copyMonthJob.launch(viewModelScope) {
            val counts = mutableMapOf<LocalDate, Int>()
            var failure: Throwable? = null
            missing.forEach { (y, m) -> copy.shiftsPerDay(rosterId, y, m).fold({ counts += it }, { failure = it }) }
            _uiState.update { s ->
                val open = s.copyTool ?: return@update s
                s.copy(copyTool = open.copy(shiftsOn = open.shiftsOn + counts, loadingMonth = false), error = failure?.copyToolText(Res.string.copy_tool_month_unreadable) ?: s.error)
            }
        }
    }

    /**
     * SH-242: a refused read in the copy tool says what could not be read, not "your role does not
     * allow this" (which the owner read as a broken account); other failures as usual.
     */
    private fun Throwable.copyToolText(refused: StringResource): UiText =
        toUiText().let { if (it == UiText.Resource(Res.string.error_permission_denied)) UiText.Resource(refused) else it }

    fun dismissCopy() {
        copyJob.launch(viewModelScope) {}
        copyMonthJob.launch(viewModelScope) {}
        _uiState.update { it.copy(copyTool = null) }
    }

    private fun editCopyTool(change: (CopyToolUiState) -> CopyToolUiState) {
        val sheet = _uiState.value.copyTool ?: return
        val changed = change(sheet)
        if (changed != sheet) updateCopyTool(changed)
    }

    /** Shows [sheet] and, on where to with a target, works out its preview; a newer choice replaces an older one. */
    private fun updateCopyTool(sheet: CopyToolUiState) {
        val copy = copyShifts ?: return
        val source = sheet.sourceSpec
        if (sheet.step != CopyToolStep.TARGET || source == null) {
            copyJob.launch(viewModelScope) {}
            _uiState.update { it.copy(copyTool = sheet.copy(isPreviewing = false, preview = null)) }
            return
        }
        _uiState.update { it.copy(copyTool = sheet.copy(isPreviewing = true, preview = null)) }
        val state = _uiState.value
        copyJob.launch(viewModelScope) {
            copy.preview(
                rosterId = rosterId,
                source = source,
                plannedDays = sheet.plannedDays,
                labourProfiles = state.labourProfiles,
                nominalMonthlyHours = state.nominalMonthlyHours,
                editorUserId = currentUserId()
            ).fold(
                onSuccess = { preview ->
                    _uiState.update { current ->
                        val open = current.copyTool ?: return@update current
                        if (!open.samePreviewAs(sheet)) return@update current
                        current.copy(copyTool = open.copy(isPreviewing = false, preview = preview))
                    }
                },
                onFailure = { e -> _uiState.update { it.copy(copyTool = null, error = e.copyToolText(Res.string.copy_tool_unreadable)) } }
            )
        }
    }

    /**
     * Writes the preview's copies in one batch. Shown at once; a failure puts the grid back. The
     * snackbar then offers one Undo, which removes exactly these shifts (and puts back what a
     * Replace removed).
     */
    fun applyCopy() {
        val state = _uiState.value
        val sheet = state.copyTool ?: return
        val preview = sheet.preview ?: return
        if (copyShifts == null || !state.canCopy || !sheet.canCopy) return
        _uiState.update { it.copy(copyTool = null) }
        writeCopies(preview)
    }

    /** Writes [preview]'s copies in one batch (shown at once); the snackbar then offers one Undo for all. */
    private fun writeCopies(preview: CopyPreview) {
        val copy = copyShifts ?: return
        val placeholders = preview.shifts.mapIndexed { i, c -> c.shift.copy(id = "${PENDING_ID_PREFIX}copy-${++editCounter}-$i") }
        placeholders.forEach { unsavedNew[it.id] = it }
        // SH-199 Replace: the replaced shifts leave the grid at once (and come back if the save fails).
        val replacedIds = preview.replaced.map { it.id }.toSet()
        val hidden = stored.filter { it.id in replacedIds }
        if (hidden.isNotEmpty()) stored = stored.filter { it.id !in replacedIds }
        publishShifts()
        viewModelScope.launch {
            // SH-148: the copies are written even if the screen is left; never twice at once.
            saves.run(copyKey) { copy.apply(preview) }.fold(
                onSuccess = { ids ->
                    AppTelemetry.log(AnalyticsEvent.ShiftsCopied)
                    recalculateAfterCopy(copy)
                    _uiState.update { it.copy(copyUndo = CopyUndo(ids, preview.replaced), gridUndo = null, deleteUndo = null) }
                    placeholders.forEach { unsavedNew.remove(it.id) }
                    // Until the listener brings the saved copies, they show under their ids.
                    val have = stored.map { it.id }.toSet()
                    stored = stored + placeholders.zip(ids).filter { (_, id) -> id !in have }.map { (p, id) -> p.copy(id = id) }
                    publishShifts()
                    refreshShifts()
                },
                onFailure = { e ->
                    placeholders.forEach { unsavedNew.remove(it.id) }
                    stored = stored + hidden.filter { h -> stored.none { it.id == h.id } }
                    publishShifts()
                    _uiState.update { it.copy(error = e.toUiText()) }
                }
            )
        }
    }

    /**
     * SH-260: the month's costs and daily records after a copy (or its undo) is written: in the
     * app's scope, queued behind other repricing of the workplace, never waited for (a month
     * replaced at once took minutes). The budget and hints read again once it is done; a failure
     * is reported and offered again ("Costs not recalculated"), the copy stays.
     */
    private fun recalculateAfterCopy(copy: CopyShiftsUseCase) {
        val workplaceId = RosterIds.workplaceIdOf(rosterId)
        saves.launch(repriceSaveKey(workplaceId), SaveKind.RECALCULATE, queue = true) {
            copy.recalculate(rosterId).also { if (it.isSuccess) scheduleDerived() }
        }
    }

    // --- SH-171: day headers copied and pasted (Ctrl/Cmd+C, Ctrl/Cmd+V) ---------------------

    /** Ctrl/Cmd+C on the grid's day headers: the selected days (or the focused one), to paste from another header. */
    fun copyDays(dates: Set<LocalDate>) {
        val state = _uiState.value
        if (copyShifts == null || !state.canCopy || dates.isEmpty()) return
        val count = dates.sumOf { state.shiftsByDate[it].orEmpty().size }
        if (count == 0) {
            _uiState.update { it.copy(notice = UiText.Resource(Res.string.copy_day_nothing_on_day)) }
            return
        }
        _uiState.update { it.copy(copiedDays = dates, notice = UiText.Resource(Res.string.copy_days_copied, listOf(dates.size, count))) }
    }

    /** Ctrl/Cmd+V on day headers: "Copy days" from the copied days, pasted from [starts] (the preview, then Copy). */
    fun pasteDays(starts: Collection<LocalDate>) {
        val sources = _uiState.value.copiedDays ?: return
        openCopyDays(sources, starts.toSet())
    }

    /** Removes the last copy's shifts, and only them. */
    fun undoCopy() {
        val copy = copyShifts ?: return
        val undo = _uiState.value.copyUndo ?: return
        if (!canBuild) return
        _uiState.update { it.copy(copyUndo = null) }
        val ids = undo.shiftIds.toSet()
        val removedShifts = stored.filter { it.id in ids }
        // SH-199: what a Replace removed shows again at once.
        val restored = undo.restore.filter { r -> stored.none { it.id == r.id } }
        stored = stored.filter { it.id !in ids } + restored
        publishShifts()
        viewModelScope.launch {
            copy.undo(rosterId, ids, undo.restore).fold(
                onSuccess = { removed ->
                    recalculateAfterCopy(copy)
                    _uiState.update { it.copy(notice = UiText.Resource(Res.string.copy_undone, listOf(removed))) }
                    refreshShifts()
                },
                onFailure = { e ->
                    val back = restored.map { it.id }.toSet()
                    stored = stored.filter { it.id !in back } + removedShifts.filter { r -> stored.none { it.id == r.id } }
                    publishShifts()
                    _uiState.update { it.copy(error = e.toUiText()) }
                }
            )
        }
    }

    /**
     * SH-158: puts the deleted shift back, as a new shift with the same day, times, person and
     * requirements (its id is new; its cost snapshot is priced again). Shown at once.
     */
    fun undoDelete() {
        val undo = _uiState.value.deleteUndo ?: return
        _uiState.update { it.copy(deleteUndo = null) }
        if (!canBuild || !_uiState.value.canEditShifts) return
        val shift = undo.shift
        val pendingId = "${PENDING_ID_PREFIX}restore-${++editCounter}"
        unsavedNew[pendingId] = shift.copy(id = pendingId)
        publishShifts()
        viewModelScope.launch {
            // SH-263: back under its own id (its removal record goes with the restore).
            val restore = deleteShiftUseCase
            val result = if (restore != null) restore.restore(shift).map { shift.id } else createShiftUseCase(shift.copy(id = ""))
            result.fold(
                onSuccess = { id ->
                    unsavedNew.remove(pendingId)
                    if (stored.none { it.id == id }) stored = stored + shift.copy(id = id)
                    publishShifts()
                    _uiState.update { it.copy(notice = UiText.Resource(Res.string.roster_shift_restored)) }
                    refreshShifts()
                },
                onFailure = { e ->
                    unsavedNew.remove(pendingId)
                    publishShifts()
                    _uiState.update { it.copy(error = e.toUiText()) }
                }
            )
        }
    }

    /** The delete's undo snackbar is gone: the shift stays deleted. */
    fun dismissDeleteUndo() {
        _uiState.update { it.copy(deleteUndo = null) }
    }

    /** The undo snackbar is gone: the copy stays. */
    fun dismissCopyUndo() {
        _uiState.update { it.copy(copyUndo = null) }
    }

    fun dismissNotice() {
        _uiState.update { it.copy(notice = null) }
    }

    /** SH-188: the error was shown; cleared so the same one can show again. */
    fun dismissError() {
        _uiState.update { it.copy(error = null) }
    }
}

/** SH-114: the first days of the weeks (starting on [firstDayOfWeek], ISO 1-7) that touch the month. */
internal fun weeksOf(year: Int, month: Int, firstDayOfWeek: Int): List<LocalDate> {
    val first = LocalDate(year, month, 1)
    val firstWeekday = firstDayOfWeek.takeIf { it in 1..7 } ?: 1
    val start = first.plus(DatePeriod(days = -((first.dayOfWeek.isoDayNumber - firstWeekday + 7) % 7)))
    val next = first.plus(DatePeriod(months = 1))
    return generateSequence(start) { it.plus(DatePeriod(days = 7)) }.takeWhile { it < next }.toList()
}

/** Contracted hours in a month: declared hours, else a salaried person's FTE share of [monthHours]. */
internal fun contractHours(engagement: FinancialEngagement, monthHours: Double): Double? =
    engagement.declaredNumberOfHours?.toDouble()?.takeIf { it > 0 }
        ?: (engagement.compensation as? CompensationModel.MonthlyFixed)?.fte?.takeIf { it > 0 }?.let { it * monthHours }

/** SH-169: the grid's zoom kept on this device (1 when none or unreadable). */
internal fun storedGridZoom(settings: com.evoapps.evoshift.settings.LocalSettings?): Float =
    settings?.getString(GRID_ZOOM_KEY)?.toFloatOrNull()?.takeIf { it.isFinite() }?.coerceIn(GRID_ZOOM_MIN, GRID_ZOOM_MAX) ?: 1f


/** SH-223: the cells' marks of approved work requests. */
object WorkMarks {
    /** The kinds that mark a day: remote work and work events (overtime is work like any other). */
    val MARKED = setOf(com.evoapps.evoshift.domain.model.WorkRequestKind.REMOTE_WORK, com.evoapps.evoshift.domain.model.WorkRequestKind.WORK_EVENT)

    /** Each person's days of [year]/[month] with an approved remote-work or work-event request, and which. */
    fun byUserAndDate(requests: List<com.evoapps.evoshift.domain.model.WorkRequest>, year: Int, month: Int):
        Map<String, Map<LocalDate, Set<com.evoapps.evoshift.domain.model.WorkRequestKind>>> {
        val first = LocalDate(year, month, 1)
        val last = first.plus(DatePeriod(months = 1)).plus(DatePeriod(days = -1))
        val out = mutableMapOf<String, MutableMap<LocalDate, MutableSet<com.evoapps.evoshift.domain.model.WorkRequestKind>>>()
        requests.filter { it.status == com.evoapps.evoshift.domain.model.AbsenceStatus.APPROVED && it.kind in MARKED }.forEach { request ->
            val start = runCatching { LocalDate.parse(request.startDate) }.getOrNull() ?: return@forEach
            val end = runCatching { LocalDate.parse(request.endDate) }.getOrNull() ?: start
            var day = maxOf(start, first)
            while (day <= minOf(end, last)) {
                out.getOrPut(request.userId) { mutableMapOf() }.getOrPut(day) { mutableSetOf() }.add(request.kind)
                day = day.plus(DatePeriod(days = 1))
            }
        }
        return out
    }

    /** The kinds marking [date] in a person's own requests (their schedule). */
    fun ofDate(requests: List<com.evoapps.evoshift.domain.model.WorkRequest>, date: String): Set<com.evoapps.evoshift.domain.model.WorkRequestKind> =
        requests.filter { it.status == com.evoapps.evoshift.domain.model.AbsenceStatus.APPROVED && it.kind in MARKED && it.startDate <= date && it.endDate >= date }
            .map { it.kind }.toSet()
}
